import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import CandidateStats from "../dashboard/stats";
import request, { NodeURL, client } from "../../api/api";
import { toast } from "react-toastify";
import FileSaver from "file-saver";
// import FileViewer from "react-file-viewer";
import { Edit } from "react-feather";
import moment from "moment";
import user from "../../assets/images/user/user.png";
import pdf from "./images/document.svg";
import portfolio from "../../../src/images/candidate/portfolio.svg";
import smartphone from "../../../src/images/candidate/smartphone.svg";
import mailsend from "../../../src/images/candidate/mail-send.svg";
import location from "../../../src/images/candidate/location.svg";
import download from "../../../src/images/candidate/download.svg";
import editdash from "../../../src/images/candidate/edit-dash.svg";
import usernumber from "../../../src/images/candidate/user-number.svg";
import openall from "../../../src/images/candidate/open-all.svg";
import closeall from "../../../src/images/candidate/close-all.svg";
import FileViewer from "react-file-viewer";

import "./profile.scss";

import {
	Card,
	CardBody,
	CardHeader,
	ModalHeader,
	ModalBody,
	Button,
	Col,
	Modal,
	UncontrolledTooltip,
	Row,
	TabContent,
	TabPane,
	Nav,
	NavItem,
	NavLink,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
} from "reactstrap";
import { CheckValue } from "../common/utils";

let append_zero = number => {
	if (number && String(number).length > 0 && String(number) !== String(undefined) && String(number) !== String(null)) {
		let find_index = String(number).indexOf('0');
		if (+find_index === 0) {
			return number;
		} else {
			return `0${number}`
		}
	} else {
		return null
	}
};

class CandidateView extends Component {
	state = {
		title: "",
		prefix_name: "",
		firstname: "",
		lastname: "",
		int: false,
		open: false,
		declarationAcceptDate: "",
		activeTab: "1",
		mainActiveTab: "1",
		acoordianToggleP1: false,
		acoordianToggleP2: false,
		acoordianTogglePaddress: false,
		acoordianTogglePwork: false,
		acoordianTogglePID: false,
		acoordianTogglePAvailability: false,
		acoordianTogglePDriving: false,
		acoordianToggleLanguage: false,
		acoordianToggleDbs: false,
		acoordianTogglekin: false,
		acoordianToggleQualification: false,
		acoordianToggleOtherQualification: false,
		acoordianToggleProfessional: false,
		acoordianToggleSkills: false,
		acoordianToggleMedical: false,
		acoordianToggleWorkingTime: false,
		acoordianToggleHealthDeclaration: false,
		acoordianTogglePersonalDeclaration: false,
		acoordianToggleConfidentiality: false,
		acoordianToggleDBSDeclaration: false,
		acoordianToggleTuberculosis: false,
		acoordianToggleCriminal: false,
		acoordianToggleDBS: false,
		acoordianToggleDISABILITY: false,
		acoordianToggleDirectives: false,
		acoordianTogglePassport: false,
		acoordianToggleVisa: false,
		acoordianToggleDriving: false,
		acoordianToggleEducation: false,
		acoordianToggleOtherEducation: false,
		acoordianToggleOtherDocuments: false,
		acoordianToggleRef1: false,
		acoordianToggleRef2: false,
		acoordianToggleRefdetails1: false,
		acoordianToggleRefApplicant1: false,
		acoordianTogglesection1: false,
		acoordianTogglesection2: false,
		acoordianTogglePLEASE: false,
		acoordianToggleRefdetails2: false,
		acoordianToggleRefApplicant2: false,
		acoordianToggleRef2SECTION1: false,
		acoordianToggleRef2SECTION2: false,
		acoordianToggleRef2PLEASE: false,
		acoordianToggleHealth: false,
		acoordianToggleHealthMedical: false,
		acoordianToggleHealthTuberculosis: false,
		acoordianToggleHealthHISTORY: false,
		acoordianToggleHealthImmunisation: false,
		acoordianToggleHealthGP: false,
		acoordianTogglePayment: false,
		acoordianTogglecovidvaccination: false,
		bankName: "", //bank
		bank_ac: "", //bank
		bank_sort_code: "", //bank
		postCode: "", //bank
		bankEmail: "", //bank
		bankPhoneError: false, //bank
		bankMobileNo: {
			//bank
			number: "",
			code: "",
			dialcountry: "gb",
		},
		dateofbirth: "",
		dateofMarriage: "",
		dateMovedAddress: "",
		availablestartdate: "",
		drivingLicenceNumber: "", // drivers details
		drivingCountryOfIssue: "", // drivers details
		licenceExpiry: "", // drivers details
		licenceClass: "", // drivers details
		traveldetails: "", // drivers details
		currentDBS: "", // DBS details
		dbsCertificateNo: "", // DBS details
		dbsIssueDate: "", // DBS details
		visaNumber: "", // ID & RIGHT WORK
		visaCountryOfIssue: "", // ID & RIGHT WORK
		visaExpiry: "", // ID & RIGHT WORK
		isNameChanged: "",
		previousNames: "",
		martialStatus: "",
		nationality: "",
		workstatus: "",
		Passportdetails: "",
		documentNumber: "",
		countryOfIssue: "",
		documentType: "", // ID & RIGHT WORK
		docTypeExpiry: "", // ID & RIGHT WORK
		professionalBody: "",
		pinRef: "",
		professionalBodyExpiry: "",
		documents: [],
		work_exp: [],
		education_qualification: [],
		other_courses: [],
		passportdocs: [],
		visadocs: [],
		drivingdocs: [],
		educationdocs: [],
		othereducationdocs: [],
		avatar: "",
		workStatus: "",
		skillProvideDetails: "",
		unique_no: "",
		signature: "",
		job_type_name: [],
		drivers_licence: {},
		drivingPhotoID: "",
		company_name: "",
		declarationAccept: false, // declaration-APPLICATION FORM DECLARATION
		dbsAccept: "", // declaration-DBS
		dbsAcceptDate: new Date(), // declaration-DBS,
		workTimeSignature: "", // declaration & terms
		workTimeDate: new Date(), // declaration & terms
		acceptHealthDeclaration: false, // declaration & terms
		HealthDeclarationDate: new Date(), // declaration & terms
		acceptPersonalDeclaration: false, // declaration & terms
		PersonalDeclarationDate: new Date(), // declaration & terms
		acceptConfidentiality: false, // declaration & terms
		ConfidentialityDate: new Date(), // declaration & terms
		openWorkingTimeSignature: false, // declaration & terms

		sufferedlongtermillness_notes: '',
		leaveforneckinjury_notes: '',
		neckinjuries_notes: '',
		sixweeksillness_notes: '',
		communicabledisease_notes: '',
		medicalattention_notes: '',
		medicalillness_notes: '',
		medicalillnesscaused_notes: '',
		treatment_notes: '',
		professional_Body: [],
		covidVaccination: '',
		GPphone: {
			code: '',
			number: '',
			dialcountry: 'gb'
		},
		user_phone: {
			code: '',
			number: '',
			dailcountry: ''
		},
	};

	download_pdf = (e) => {
		let toastId = "referee_form_download_022";
		client.defaults.responseType = "blob";
		toastId = toast.info("Downloading......", { autoClose: 7500 });
		e.preventDefault();
		request({
			url: "/candidate/onlineform/download/pdf",
			method: "POST",
			data: {
				host: window.location.hostname,
				protocol: window.location.protocol,
				port: window.location.port
			},
		})
			.then((res) => {
				if (res) {
					toast.update(toastId, {
						render: "Downloaded!",
						type: toast.TYPE.SUCCESS,
						autoClose: 2500,
					});
					const file = new Blob([res], { type: "application/pdf" });
					FileSaver(file, `${this.state.prefix_name} Application form.pdf`);
					this.componentDidMount();
				} else {
					toast.error(res.response);
				}
				client.defaults.responseType = "json";
			})
			.catch((error) => {
				client.defaults.responseType = "json";
				toast.update(toastId, {
					render: error,
					type: toast.TYPE.ERROR,
					autoClose: 2500,
				});
				console.log(`err at download_pdf ${error}`);
			});
	};

	componentDidMount() {

		// toast.success('Success response')
		// toast.error('error response')
		// toast.info('Warning response')

		this.call_timer1 = setInterval(() => {
			this.setState({ int: false });
		}, 1500000);
		this.call_timer2 = setInterval(() => {
			this.setState({ int: true });
		}, 1800000);
		request({
			url: "/employee/profile",
			method: "POST",
		}).then((res) => {
			if (res.status === 1) {
				const res_result = res.response.result ? res.response.result : "";
				const bankDetails = res_result.bank_details
					? res_result.bank_details
					: {};
				const form_data = res_result.onlineform ? res_result.onlineform : {};
				const aboutyourwork = form_data.aboutyourwork;
				const form_status =
					res_result.onlineform && res_result.onlineform.form_status
						? res_result.onlineform.form_status
						: 0;
				const formgp =
					res_result.onlineform &&
						res_result.onlineform.gpdetails
						? res_result.onlineform.gpdetails
						: {};
				if (res_result && res_result.avatar && res_result.avatar.length > 0) {
					this.setState({ avatar: res_result.avatar });
				}
				if (
					res_result &&
					res_result.signature &&
					res_result.signature.length > 0
				) {
					this.setState({ signature: res_result.signature });
				}
				this.setState({
					job_type_name:
						res_result && res_result.job_type_name
							? res_result.job_type_name
							: [],
					covidVaccination: res_result && res_result.covidVaccination && CheckValue(res_result.covidVaccination) ? res_result.covidVaccination : ''
				});
				this.setState({
					drivingPhotoID:
						form_data &&
							form_data.drivingdetails &&
							form_data.drivingdetails.drivingPhotoID
							? form_data.drivingdetails.drivingPhotoID
							: "",
				});
				let user_phone = {
					code: res_result && res_result.phone && CheckValue(res_result.phone.code) ? res_result.phone.code : '',
					number: res_result && res_result.phone && CheckValue(res_result.phone.number) ? res_result.phone.number : '',
					dailcountry: res_result && res_result.phone && CheckValue(res_result.phone.dailcountry) ? res_result.phone.dailcountry : ''
				};
				if (form_data) {
					this.setState({
						user_phone: user_phone,
						GPphone: formgp && formgp.GPphone && formgp.GPphone.number && formgp.GPphone.number.length > 0 ?
							formgp.GPphone : {
								number: "",
								code: "",
								dailcountry: "gb",
							},
						declarationAccept:
							form_data.declaration && form_data.declaration.declarationAccept, // declaration
						declarationAcceptDate:
							form_data.declaration &&
								form_data.declaration.declarationAcceptDate === "" || String(form_data.declaration.declarationAcceptDate) === String(undefined) || String(form_data.declaration.declarationAcceptDate) === String(null) || String(form_data.declaration.declarationAcceptDate) === String('Invalid date')
								? ""
								: moment(form_data.declaration.declarationAcceptDate).format(
									"DD-MM-YYYY"
								),
						workTimeSignature:
							form_data && form_data.worktimedirectives
								? form_data.worktimedirectives.signature
								: "",
						workTimeDate:
							form_data && form_data.worktimedirectives
								? form_data.worktimedirectives.date
								: new Date(),
						acceptHealthDeclaration:
							form_data && form_data.healthDeclarationTerms
								? form_data.healthDeclarationTerms.acceptHealthDeclaration
								: "",
						HealthDeclarationDate:
							form_data && form_data.healthDeclarationTerms
								? form_data.healthDeclarationTerms.date
								: new Date(),
						acceptPersonalDeclaration:
							form_data && form_data.personalDeclarationTerms
								? form_data.personalDeclarationTerms.acceptPersonalDeclaration
								: "",
						PersonalDeclarationDate:
							form_data && form_data.personalDeclarationTerms
								? form_data.personalDeclarationTerms.date
								: new Date(),
						acceptConfidentiality:
							form_data && form_data.confidentialityTerms
								? form_data.confidentialityTerms.acceptConfidentiality
								: "",
						ConfidentialityDate:
							form_data && form_data.confidentialityTerms
								? form_data.confidentialityTerms.date
								: new Date(),
						dbsAcceptDate:
							form_data && form_data.dbsDeclaration
								? form_data.dbsDeclaration.date
								: new Date(),
						dbsAccept:
							form_data && form_data.dbsDeclaration
								? form_data.dbsDeclaration.dbsAccept
								: '',
						visaNumber:
							res_result &&
								res_result.visa_info &&
								res_result.visa_info.visa_number
								? res_result.visa_info.visa_number
								: "",
						visaCountryOfIssue:
							res_result &&
								res_result.visa_info &&
								res_result.visa_info.country_of_issue
								? res_result.visa_info.country_of_issue
								: "",
						visaExpiry:
							res_result &&
								res_result.visa_info &&
								res_result.visa_info.visa_expiry
								? res_result.visa_info.visa_expiry
								: "",
						availablestartdate: aboutyourwork.availablestartdate,
						title:
							form_data &&
								form_data.personaldetails &&
								form_data.personaldetails.title
								? form_data.personaldetails.title
								: "",
						prefix_name: res_result.name,
						firstname: res_result.name,
						lastname: res_result.surname,
						professional_Body: form_data.professional_Body && form_data.professional_Body.length > 0 && Array.isArray(form_data.professional_Body) ? form_data.professional_Body : [],
						professionalBody:
							form_data.professionalBody &&
								form_data.professionalBody.professionalBody &&
								form_data.professionalBody.professionalBody.length > 0
								? form_data.professionalBody.professionalBody
								: "",
						pinRef:
							form_data.professionalBody &&
								form_data.professionalBody.pinRef &&
								form_data.professionalBody.pinRef.length > 0
								? form_data.professionalBody.pinRef
								: "",
						professionalBodyExpiry:
							form_data.professionalBody &&
								form_data.professionalBody.professionalBodyExpiry === "" || String(form_data.professionalBody.professionalBodyExpiry) === String(undefined) || String(form_data.professionalBody.professionalBodyExpiry) === String(null) || String(form_data.professionalBody.professionalBodyExpiry) === String('Invalid date')
								? ""
								: moment(
									form_data.professionalBody.professionalBodyExpiry
								).format("DD-MM-YYYY"),

						documentType:
							form_data &&
							form_data.righttowork &&
							form_data.righttowork.documentType,
						docTypeExpiry:
							form_data &&
								form_data.righttowork &&
								form_data.righttowork.docTypeExpiry && String(form_data.righttowork.docTypeExpiry) !== String(undefined) && String(form_data.righttowork.docTypeExpiry) !== String(null) && String(form_data.righttowork.docTypeExpiry) !== String('Invalid date')
								? moment(form_data.righttowork.docTypeExpiry).format(
									"DD-MM-YYYY"
								)
								: undefined,
						countryOfIssue:
							form_data &&
								form_data.righttowork &&
								form_data.righttowork.countryOfIssue
								? form_data.righttowork.countryOfIssue
								: undefined,
						Passportdetails:
							form_data &&
								form_data.righttowork &&
								form_data.righttowork.Passportdetails
								? form_data.righttowork.Passportdetails
								: undefined,
						documentNumber:
							form_data &&
								form_data.righttowork &&
								form_data.righttowork.documentNumber
								? form_data.righttowork.documentNumber
								: undefined,
						drivers_licence:
							res_result &&
								res_result.drivers_licence &&
								res_result.drivers_licence
								? res_result.drivers_licence
								: {},
						licenceExpiry:
							res_result &&
								res_result.drivers_licence &&
								res_result.drivers_licence.licenceExpiry === "" || String(res_result.drivers_licence.licenceExpiry) === String(undefined) || String(res_result.drivers_licence.licenceExpiry) === String(null) || String(res_result.drivers_licence.licenceExpiry) === String('Invalid date')
								? ""
								: moment(res_result.drivers_licence.licenceExpiry).format(
									"DD-MM-YYYY"
								), // drivers details
						drivingLicenceNumber:
							res_result &&
							res_result.drivers_licence &&
							res_result.drivers_licence.drivingLicenceNumber, // drivers details
						drivingCountryOfIssue:
							res_result &&
							res_result.drivers_licence &&
							res_result.drivers_licence.drivingCountryOfIssue, // drivers details
						licenceClass:
							res_result &&
							res_result.drivers_licence &&
							res_result.drivers_licence.licenceClass, // drivers details
						// traveldetails:
						//   form_data &&
						//   form_data.drivingdetails &&
						//   form_data.drivingdetails.traveldetails, // drivers details
						currentDBS:
							form_data &&
							form_data.personaldetails &&
							form_data.personaldetails.iscurrentDBS, // DBS details
						dbsCertificateNo:
							form_data &&
							form_data.personaldetails &&
							form_data.personaldetails.dbsCertificateNo, // DBS details
						dbsIssueDate:
							form_data &&
								form_data.personaldetails &&
								form_data.personaldetails.dbsIssueDate && String(form_data.personaldetails.dbsIssueDate) !== String(undefined) && String(form_data.personaldetails.dbsIssueDate) !== String(null) && String(form_data.personaldetails.dbsIssueDate) !== String('Invalid date')
								? moment(form_data.personaldetails.dbsIssueDate).format(
									"DD-MM-YYYY"
								)
								: "",
						accountName: bankDetails.accountName, //bank
						accountType: bankDetails.accountType, //bank
						bankName: bankDetails.bankName, //bank
						bank_ac: bankDetails.bank_ac_name, //bank
						bank_sort_code: bankDetails.bank_sort_code, //bank
						postCode: bankDetails.postCode, //bank
						bankEmail: bankDetails.bankEmail, //bank
						bankMobileNo: {
							//bank
							number:
								bankDetails &&
									bankDetails.bank_number &&
									bankDetails.bank_number.number
									? bankDetails.bank_number.number
									: "",
							code:
								bankDetails &&
									bankDetails.bank_number &&
									bankDetails.bank_number.code
									? bankDetails.bank_number.code
									: "",
							dialcountry:
								bankDetails &&
									bankDetails.bank_number &&
									bankDetails.bank_number.dailcountry
									? bankDetails.bank_number.dailcountry
									: "gb",
						},
						dateofbirth:
							form_data && form_data.personaldetails.dateofbirth === "" || String(form_data.personaldetails.dateofbirth) === String(null) || String(form_data.personaldetails.dateofbirth) === String(undefined) || String(form_data.personaldetails.dateofbirth) === String('Invalid date')
								? ""
								: moment(form_data.personaldetails.dateofbirth).format(
									"DD-MM-YYYY"
								),
						dateofMarriage:
							form_data &&
								form_data.personaldetails &&
								form_data.personaldetails.dateofMarriage && String(form_data.personaldetails.dateofMarriage) !== String(null) && String(form_data.personaldetails.dateofMarriage) !== String(undefined) && String(form_data.personaldetails.dateofMarriage) !== String('Invalid date')
								? moment(form_data.personaldetails.dateofMarriage).format(
									"DD-MM-YYYY"
								)
								: this.state.dateofMarriage,
						dateMovedAddress:
							form_data.personaldetails &&
							form_data.personaldetails.dateMovedAddress, // address
						form_status: form_status,
						form_data: form_data,
						employee_data: res_result,
						documents: res_result.documents,
						education_qualification: res_result.education_qualification,
						other_courses: res_result.other_courses,
						passportdocs:
							form_data.uploadpassport && form_data.uploadpassport.length > 0
								? form_data.uploadpassport
								: [],
						visadocs:
							form_data.uploadvisa && form_data.uploadvisa.length > 0
								? form_data.uploadvisa
								: [],
						drivingdocs:
							form_data.uploaddriving && form_data.uploaddriving.length > 0
								? form_data.uploaddriving
								: [],
						educationdocs:
							form_data.uploadeducationcertificate &&
								form_data.uploadeducationcertificate.length > 0
								? form_data.uploadeducationcertificate
								: [],
						othereducationdocs:
							form_data.uploadothereducationcertificate &&
								form_data.uploadothereducationcertificate.length > 0
								? form_data.uploadothereducationcertificate
								: [],
						unique_no: res_result.unique_no,
						work_exp: res_result.work_exp,
						workStatus: form_data.workstatus,
						employee_email: res_result.email,
						skillProvideDetails: form_data.skillProvideDetails,
						sufferedlongtermillness_notes:
							form_data.healthdeclaration &&
								form_data.healthdeclaration.sufferedlongtermillness_notes ? form_data.healthdeclaration.sufferedlongtermillness_notes : '',
						leaveforneckinjury_notes:
							form_data.healthdeclaration &&
								form_data.healthdeclaration.leaveforneckinjury_notes ? form_data.healthdeclaration.leaveforneckinjury_notes : '',
						neckinjuries_notes:
							form_data.healthdeclaration &&
								form_data.healthdeclaration.neckinjuries_notes ? form_data.healthdeclaration.neckinjuries_notes : '',
						sixweeksillness_notes:
							form_data.healthdeclaration &&
								form_data.healthdeclaration.sixweeksillness_notes ? form_data.healthdeclaration.sixweeksillness_notes : '',
						communicabledisease_notes:
							form_data.healthdeclaration &&
								form_data.healthdeclaration.communicabledisease_notes ? form_data.healthdeclaration.communicabledisease_notes : '',
						medicalattention_notes:
							form_data.healthdeclaration &&
								form_data.healthdeclaration.medicalattention_notes ? form_data.healthdeclaration.medicalattention_notes : '',
						medicalillness_notes:
							form_data.medicalhistory &&
								form_data.medicalhistory.medicalillness_notes ? form_data.medicalhistory.medicalillness_notes : '',
						medicalillnesscaused_notes:
							form_data.medicalhistory &&
								form_data.medicalhistory.medicalillnesscaused_notes ? form_data.medicalhistory.medicalillnesscaused_notes : '',
						treatment_notes:
							form_data.medicalhistory && form_data.medicalhistory.treatment_notes ? form_data.medicalhistory && form_data.medicalhistory.treatment_notes : ''
					});
				}
			} else if (res.status === 0) {
				toast.error(res.response);
			}
		});
		request({
			url: "/employee/agencydetails",
			method: "POST",
		}).then((res) => {
			if (res.status === 1) {
				if (
					res.response &&
					res.response.result &&
					res.response.result.length > 0
				) {
					this.setState({
						company_name: res.response.result[0].company_name || "",
						jobtypelist: res.response.result[0].jobtypes || {},
					});
				}
			} else if (res.status === 0) {
				toast.error(res.response);
			}
		});
	}

	componentWillUnmount = () => {
		clearInterval(this.call_timer1);
		clearInterval(this.call_timer2);
	};

	FileDownloader = (filepath, name) => {
		let toastId = "downloadfiles156";
		toastId = toast.info("Please Wait......", { autoClose: false });
		if (filepath) {
			var oReq = new XMLHttpRequest();
			let filess = NodeURL + "/" + filepath;
			if (window.location.port && window.location.port.length > 1) {
				filess = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/${filepath}`;
			} else {
				filess = `${window.location.protocol}//${window.location.hostname}/${filepath}`;
			}
			var URLToPDF = filess;
			oReq.open("GET", URLToPDF, true);
			oReq.setRequestHeader("Access-Control-Allow-Origin", "*");
			oReq.responseType = "blob";
			oReq.onload = function () {
				var file = new Blob([oReq.response], {
					type: "application/pdf",
				});
				FileSaver.saveAs(file, `${name}`);
			};
			oReq.send();
			// const file = NodeURL + "/" + filepath;
			// FileSaver.saveAs(file, name);
			toast.update(toastId, {
				render: "File Downloaded!",
				type: toast.TYPE.SUCCESS,
				autoClose: 2500,
			});
		} else {
			toast.update(toastId, {
				render: "Unable to Download",
				type: toast.TYPE.ERROR,
				autoClose: 2500,
			});
		}
	};
	FileView = (path) => {
		if (path) {
			const filepath = `${NodeURL}/${path}`;
			let fileext = path && path.split(".");
			fileext = fileext[fileext.length - 1];
			this.setState({ filepath, fileext, fileviewmodal: true });
		} else {
			this.setState({ fileviewmodal: false });
		}
	};

	editpage = (e, id) => {
		e.stopPropagation();
		return this.props.history.push({
			pathname: "/profile/editprofile",
		});
	};

	toggle = (tab) => {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab,
			});
		}
	};
	mainToggle = (tab) => {
		if (this.state.mainActiveTab !== tab) {
			this.setState({
				mainActiveTab: tab,
			});
		}
	};

	onToggleAccordian = (data) => {
		if (data === "p1")
			this.setState({
				acoordianToggleP1: !this.state.acoordianToggleP1,
			});
		if (data === "p2")
			this.setState({
				acoordianToggleP2: !this.state.acoordianToggleP2,
			});
		if (data === "paddress")
			this.setState({
				acoordianTogglePaddress: !this.state.acoordianTogglePaddress,
			});
		if (data === "Pwork")
			this.setState({
				acoordianTogglePwork: !this.state.acoordianTogglePwork,
			});
		if (data === "PID")
			this.setState({
				acoordianTogglePID: !this.state.acoordianTogglePID,
			});
		if (data === "PAvailability")
			this.setState({
				acoordianTogglePAvailability: !this.state.acoordianTogglePAvailability,
			});
		if (data === "PDriving")
			this.setState({
				acoordianTogglePDriving: !this.state.acoordianTogglePDriving,
			});
		if (data === "Language")
			this.setState({
				acoordianToggleLanguage: !this.state.acoordianToggleLanguage,
			});
		if (data === "Dbs")
			this.setState({
				acoordianToggleDbs: !this.state.acoordianToggleDbs,
			});
		if (data === "kin")
			this.setState({
				acoordianTogglekin: !this.state.acoordianTogglekin,
			});
	};
	onToggleAccordianEmployment = (data) => {
		if (data === "Qualification")
			this.setState({
				acoordianToggleQualification: !this.state.acoordianToggleQualification,
			});
		if (data === "OtherQualification")
			this.setState({
				acoordianToggleOtherQualification: !this.state
					.acoordianToggleOtherQualification,
			});
		if (data === "Professional")
			this.setState({
				acoordianToggleProfessional: !this.state.acoordianToggleProfessional,
			});
		if (data === "Skills")
			this.setState({
				acoordianToggleSkills: !this.state.acoordianToggleSkills,
			});
	};
	onToggleAccordianDeclaration = (data) => {
		if (data === "WorkingTime")
			this.setState({
				acoordianToggleWorkingTime: !this.state.acoordianToggleWorkingTime,
			});
		if (data === "HealthDeclaration")
			this.setState({
				acoordianToggleHealthDeclaration: !this.state
					.acoordianToggleHealthDeclaration,
			});
		if (data === "PersonalDeclaration")
			this.setState({
				acoordianTogglePersonalDeclaration: !this.state
					.acoordianTogglePersonalDeclaration,
			});
		if (data === "Confidentiality")
			this.setState({
				acoordianToggleConfidentiality: !this.state
					.acoordianToggleConfidentiality,
			});
		if (data === "DBSDeclaration")
			this.setState({
				acoordianToggleDBSDeclaration: !this.state
					.acoordianToggleDBSDeclaration,
			});
		if (data === "Medical")
			this.setState({
				acoordianToggleMedical: !this.state.acoordianToggleMedical,
			});
		if (data === "Tuberculosis")
			this.setState({
				acoordianToggleTuberculosis: !this.state.acoordianToggleTuberculosis,
			});
		if (data === "Criminal")
			this.setState({
				acoordianToggleCriminal: !this.state.acoordianToggleCriminal,
			});
		if (data === "DBS")
			this.setState({
				acoordianToggleDBS: !this.state.acoordianToggleDBS,
			});
		if (data === "DISABILITY")
			this.setState({
				acoordianToggleDISABILITY: !this.state.acoordianToggleDISABILITY,
			});
		if (data === "Directives")
			this.setState({
				acoordianToggleDirectives: !this.state.acoordianToggleDirectives,
			});
	};
	onToggleAccordianDocuments = (data) => {
		if (data === "Passport")
			this.setState({
				acoordianTogglePassport: !this.state.acoordianTogglePassport,
			});
		if (data === "Visa")
			this.setState({
				acoordianToggleVisa: !this.state.acoordianToggleVisa,
			});
		if (data === "Driving")
			this.setState({
				acoordianToggleDriving: !this.state.acoordianToggleDriving,
			});
		if (data === "Education")
			this.setState({
				acoordianToggleEducation: !this.state.acoordianToggleEducation,
			});
		if (data === "OtherEducation")
			this.setState({
				acoordianToggleOtherEducation: !this.state
					.acoordianToggleOtherEducation,
			});
		if (data === "Documents")
			this.setState({
				acoordianToggleOtherDocuments: !this.state
					.acoordianToggleOtherDocuments,
			});
	};
	onToggleAccordianReference = (data) => {
		if (data === "Ref1")
			this.setState({
				acoordianToggleRef1: !this.state.acoordianToggleRef1,
			});
		if (data === "Ref2")
			this.setState({
				acoordianToggleRef2: !this.state.acoordianToggleRef2,
			});
		if (data === "Refdetails1")
			this.setState({
				acoordianToggleRefdetails1: !this.state.acoordianToggleRefdetails1,
			});
		if (data === "RefApplicant1")
			this.setState({
				acoordianToggleRefApplicant1: !this.state.acoordianToggleRefApplicant1,
			});
		if (data === "section1")
			this.setState({
				acoordianTogglesection1: !this.state.acoordianTogglesection1,
			});
		if (data === "section2")
			this.setState({
				acoordianTogglesection2: !this.state.acoordianTogglesection2,
			});
		if (data === "PLEASE")
			this.setState({
				acoordianTogglePLEASE: !this.state.acoordianTogglePLEASE,
			});
		if (data === "Refdetails2")
			this.setState({
				acoordianToggleRefdetails2: !this.state.acoordianToggleRefdetails2,
			});
		if (data === "RefApplicant2")
			this.setState({
				acoordianToggleRefApplicant2: !this.state.acoordianToggleRefApplicant2,
			});
		if (data === "Ref2SECTION1")
			this.setState({
				acoordianToggleRef2SECTION1: !this.state.acoordianToggleRef2SECTION1,
			});
		if (data === "Ref2SECTION2")
			this.setState({
				acoordianToggleRef2SECTION2: !this.state.acoordianToggleRef2SECTION2,
			});
		if (data === "Ref2PLEASE")
			this.setState({
				acoordianToggleRef2PLEASE: !this.state.acoordianToggleRef2PLEASE,
			});
	};
	onToggleAccordianHealth = (data) => {
		if (String(data) === 'COVIDVACCINATION') {
			this.setState({ acoordianTogglecovidvaccination: !this.state.acoordianTogglecovidvaccination });
		}
		if (data === "Health")
			this.setState({
				acoordianToggleHealth: !this.state.acoordianToggleHealth,
			});
		if (data === "HealthMedical")
			this.setState({
				acoordianToggleHealthMedical: !this.state.acoordianToggleHealthMedical,
			});
		if (data === "HealthTuberculosis")
			this.setState({
				acoordianToggleHealthTuberculosis: !this.state
					.acoordianToggleHealthTuberculosis,
			});
		if (data === "HealthHISTORY")
			this.setState({
				acoordianToggleHealthHISTORY: !this.state.acoordianToggleHealthHISTORY,
			});
		if (data === "HealthImmunisation")
			this.setState({
				acoordianToggleHealthImmunisation: !this.state
					.acoordianToggleHealthImmunisation,
			});
		if (data === "HealthGP")
			this.setState({
				acoordianToggleHealthGP: !this.state.acoordianToggleHealthGP,
			});
		if (data === "Payment")
			this.setState({
				acoordianTogglePayment: !this.state.acoordianTogglePayment,
			});
	};
	openAllAccordian = () => {
		this.setState({
			open: !this.state.open,
			acoordianToggleP1: !this.state.acoordianToggleP1,
			acoordianToggleP2: !this.state.acoordianToggleP2,
			acoordianTogglePaddress: !this.state.acoordianTogglePaddress,
			acoordianTogglePwork: !this.state.acoordianTogglePwork,
			acoordianTogglePID: !this.state.acoordianTogglePID,
			acoordianTogglePAvailability: !this.state.acoordianTogglePAvailability,
			acoordianTogglePDriving: !this.state.acoordianTogglePDriving,
			acoordianToggleLanguage: !this.state.acoordianToggleLanguage,
			acoordianToggleDbs: !this.state.acoordianToggleDbs,
			acoordianTogglekin: !this.state.acoordianTogglekin,
			acoordianToggleQualification: !this.state.acoordianToggleQualification,
			acoordianToggleOtherQualification: !this.state
				.acoordianToggleOtherQualification,
			acoordianToggleProfessional: !this.state.acoordianToggleProfessional,
			acoordianToggleSkills: !this.state.acoordianToggleSkills,
			acoordianToggleMedical: !this.state.acoordianToggleMedical,
			acoordianToggleWorkingTime: !this.state.acoordianToggleWorkingTime,
			acoordianToggleHealthDeclaration: !this.state
				.acoordianToggleHealthDeclaration,
			acoordianTogglePersonalDeclaration: !this.state
				.acoordianTogglePersonalDeclaration,
			acoordianToggleConfidentiality: !this.state
				.acoordianToggleConfidentiality,
			acoordianToggleDBSDeclaration: !this.state.acoordianToggleDBSDeclaration,
			acoordianToggleTuberculosis: !this.state.acoordianToggleTuberculosis,
			acoordianToggleCriminal: !this.state.acoordianToggleDBS,
			acoordianToggleDBS: !this.state.acoordianToggleDBS,
			acoordianToggleDISABILITY: !this.state.acoordianToggleDISABILITY,
			acoordianToggleDirectives: !this.state.acoordianToggleDirectives,
			acoordianTogglePassport: !this.state.acoordianTogglePassport,
			acoordianToggleVisa: !this.state.acoordianToggleVisa,
			acoordianToggleDriving: !this.state.acoordianToggleDriving,
			acoordianToggleEducation: !this.state.acoordianToggleEducation,
			acoordianToggleOtherEducation: !this.state.acoordianToggleOtherEducation,
			acoordianToggleOtherDocuments: !this.state.acoordianToggleOtherDocuments,
			acoordianToggleRef1: !this.state.acoordianToggleRef1,
			acoordianToggleRef2: !this.state.acoordianToggleRef2,
			acoordianToggleRefdetails1: !this.state.acoordianToggleRefdetails1,
			acoordianToggleRefApplicant1: !this.state.acoordianToggleRefApplicant1,
			acoordianTogglesection1: !this.state.acoordianTogglesection1,
			acoordianTogglesection2: !this.state.acoordianTogglesection2,
			acoordianTogglePLEASE: !this.state.acoordianTogglePLEASE,
			acoordianToggleRefdetails2: !this.state.acoordianToggleRefdetails2,
			acoordianToggleRefApplicant2: !this.state.acoordianToggleRefApplicant2,
			acoordianToggleRef2SECTION1: !this.state.acoordianToggleRef2SECTION1,
			acoordianToggleRef2SECTION2: !this.state.acoordianToggleRef2SECTION2,
			acoordianToggleRef2PLEASE: !this.state.acoordianToggleRef2PLEASE,
			acoordianToggleHealth: !this.state.acoordianToggleHealth,
			acoordianToggleHealthMedical: !this.state.acoordianToggleHealthMedical,
			acoordianToggleHealthTuberculosis: !this.state
				.acoordianToggleHealthTuberculosis,
			acoordianToggleHealthHISTORY: !this.state.acoordianToggleHealthHISTORY,
			acoordianTogglecovidvaccination: !this.state.acoordianTogglecovidvaccination,
			acoordianToggleHealthImmunisation: !this.state
				.acoordianToggleHealthImmunisation,
			acoordianToggleHealthGP: !this.state.acoordianToggleHealthGP,
			acoordianTogglePayment: !this.state.acoordianTogglePayment,
		});
	};

	render() {
		const {
			declarationAccept,
			workStatus,
			form_data,
			filepath,
			fileext,
			avatar,
			unique_no,
			signature,
			drivers_licence,
			drivingPhotoID,
			employee_email,
			workTimeSignature,
			user_phone
		} = this.state;
		let {
			registereddisabled,
			disableAct,
			disableActDetails,
			disableOverCome,
			disableOverComeDetails,
			disableRegisteredDetails,
		} = form_data && form_data.disable_act ? form_data.disable_act : {};
		let {
			criminaloffence,
			criminalCautioned,
			criminalConvictions,
			criminalCourt,
			criminalDisciplinaryAction,
			criminalAdditionalInformation,
		} =
			form_data && form_data.criminal_records ? form_data.criminal_records : {};
		const {
			// form_status,
			skillcheck: form_skillcheck,
			healthcheck: form_healthcheck,
			dbscheck: form_dbscheck,
			interview: form_interview,
			personaldetails: form_personaldetails,
			drivingdetails: form_driving,
			nextofkindetails: form_kin,
			gpdetails: form_gp,
			postapplyfor,
			postapplydetails,
			availablestartdate,
			UploadIDPhoto,
			// employmenteligibility: { visapermit, visapermittype } = {},
			UploadCV,
			langauages: {
				englishspoken,
				englishwritten,
				otherlanguage,
				IELTStest,
			} = {},
			employmenthistory: employmenthistorylist,
			education: educationlist,
			reference1,
			reference1: { referee: form_reference1 } = {},
			reference2,
			reference2: { referee: form_reference2 } = {},
			mandatory_training,
			movinghandling,
			basiclifesupport,
			healthsafety,
			firesafety,
			firstaid,
			infectioncontrol,
			foodsafety,
			medicationadmin,
			safeguardingvulnerable,
			trainingdates,
			healthcare_training,
			diplomal3,
			diplomal2,
			personalsafetymental,
			intermediatelife,
			advancedlife,
			complaintshandling,
			handlingviolence,
			doolsmental,
			coshh,
			dataprotection,
			equalityinclusion,
			loneworkertraining,
			resuscitation,
			interpretation,
			trainindates2,
			healthdeclaration,
			medicalhistory: {
				medicalillness,
				medicalillnesscaused,
				treatment,
				needanyadjustments,
				needanyadjustmentsnotes,
			} = {},
			tuberculosis: {
				livedUK,
				livedUKnotes,
				BCGvaccination,
				BCGvaccinationdate,
				cough,
				weightloss,
				fever,
				TB,
			} = {},
			chickenpoxorshingles: { chickenpoxdate } = {},
			immunisationhistory: {
				chickenpox,
				polio,
				tetanus,
				hepatitisB,
				hepatitis,
				proneProcedures,
				heartCirculatory,
				diabetes,
				asthma,
				bronchitis,
				epilepsy,
				headaches,
				psychiatric,
				dermatitis,
				backProblems,
				recurrentInfections,
				varicella,
				heaf,
				tuberculosis,
				rubella,
				poliomyelitis,
				typhoid,
				HIV,
			} = {},
			declaration: {
				// occupationalHealthServices,
				// criminaloffence,
				warningcriminaloffence,
				// DBSdetails
			} = {},
			righttowork: { passport } = {},
			worktimedirectives: { workhours } = {},
			uploadcertificate: certificatedocs,
			uploadpassport: passportdocs,
			uploadaddress: addressdocs,
			uploaddbs: dbsdocs,
			uploadothers: otherdocs,
			final_verify_status,
			final_verify_date,
			final_verify_notes,
			dbsAccept,
		} = form_data ? form_data : {};
		const {
			abletowork: form_aboutwork,
			shortnotice,
			reduceworkflexibility,
			workstate,
		} = form_data && form_data.aboutyourwork ? form_data.aboutyourwork : {};
		const {
			date: skillcheckdate,
			notes: skillchecknotes,
			status: skillcheckstatus,
		} = form_skillcheck ? form_skillcheck : {};
		const {
			date: dbscheckdate,
			notes: dbschecknotes,
			status: dbscheckstatus,
		} = form_dbscheck ? form_dbscheck : {};
		const {
			date: healthcheckdate,
			notes: healthchecknotes,
			status: healthcheckstatus,
		} = form_healthcheck ? form_healthcheck : {};
		const {
			interviewdate,
			interviewnotes,
			intervieweddate,
			interviewednotes,
			status: interviewedstatus,
			videocallurl,
		} = form_interview ? form_interview : {};
		const {
			title,
			firstname = "",
			prefferedName,
			middlename,
			lastname = "",
			maidenName,
			homephone,
			email,
			previousName,
			isNameChanged,
			martialStatus,
			// dateofbirth,
			insuranceno,
			nationality,
			gender,
			religion,
			race,
			sexualorientation,
			address: { streetAddress, addressline2, city, state, zip, country } = {},
			mobileno,
		} = form_personaldetails ? form_personaldetails : {};
		const {
			vehicledocumentsvalid,
			drivinglicence,
			traveldetails,
			drivinglicenceno,
			caraccess,
			bannedfromdriving,
			carinsurance,
		} = form_driving ? form_driving : {};
		const {
			work_mornings,
			work_evenings,
			work_afternoons,
			work_occasional,
			work_fulltime,
			work_parttime,
			work_nights,
			work_weekends,
			work_anytime,
		} = form_aboutwork ? form_aboutwork : {};
		const {
			kinprefix,
			kinfirstname,
			kinlastname,
			kinrelationship,
			kinhomephone,
			kinmobileno,
			kinemail,
			Address: {
				kinstreetAddress,
				kinaddressline2,
				kincity,
				kinstate,
				kinzip,
				kincountry,
			} = {},
		} = form_kin ? form_kin : {};
		const {
			firstrefrelationship,
			firstreffirstname,
			firstreflastname,
			firstrefphone,
			firstrefemail,
			Address: {
				firstrefstreetAddress,
				firstrefcity,
				firstrefstate,
				firstrefzip,
			} = {},
		} = reference1 ? reference1 : {};
		const {
			secondrefrelationship,
			secondreffirstname,
			secondreflastname,
			secondrefphone,
			secondrefemail,
			Address: {
				secondrefstreetAddress,
				secondrefcity,
				secondrefstate,
				secondrefzip,
			} = {},
		} = reference2 ? reference2 : {};
		const {
			sufferedlongtermillness,
			leaveforneckinjury,
			neckinjuries,
			sixweeksillness,
			communicabledisease,
			medicalattention,
			healthdeclarationdetails,
			absentfromwork,
			statereason,
		} = healthdeclaration ? healthdeclaration : {};
		const {
			GPname,
			gpaddress: {
				GPstreetAddress,
				GPcity,
				GPstate,
				GPzip,
				contactDoctor,
				GPhealthdetails,
			} = {},
		} = form_gp ? form_gp : {};
		const {
			refereefirstname,
			refereelastname,
			refereeemail,
			refereephone,
			refereejobtitle,
			refereecompany,
			refereecapacity,
			applicantfirstname,
			applicantlastname,
			applicantemail,
			applicantphone,
			applicantjobtitle,
			applicantcompany,
			employedfrom,
			employedto,
			remployee,
			remployeenotes,
			followcareplans,
			reliability,
			character,
			dignity,
			attitude,
			communication,
			relationships,
			workunderinitiative,
			disciplinaryaction,
			disciplinaryactiondetails,
			investigations,
			investigationsdetails,
			vulnerablepeople,
			vulnerablepeopledetails,
			criminaloffences,
			criminaloffencedetails,
			additionalcomments,
			campanystamp,
			referenceverifydate,
			// referenceverifynotes
		} = form_reference1 ? form_reference1 : {};
		const reference_details1 = form_reference1;
		const {
			refereefirstname: refereefirstname2,
			refereelastname: refereelastname2,
			refereeemail: refereeemail2,
			refereephone: refereephone2,
			refereejobtitle: refereejobtitle2,
			refereecompany: refereecompany2,
			refereecapacity: refereecapacity2,
			applicantfirstname: applicantfirstname2,
			applicantlastname: applicantlastname2,
			applicantemail: applicantemail2,
			applicantphone: applicantphone2,
			applicantjobtitle: applicantjobtitle2,
			applicantcompany: applicantcompany2,
			employedfrom: employedfrom2,
			employedto: employedto2,
			remployee: remployee2,
			remployeenotes: remployeenotes2,
			followcareplans: followcareplans2,
			reliability: reliability2,
			character: character2,
			dignity: dignity2,
			attitude: attitude2,
			communication: communication2,
			relationships: relationships2,
			workunderinitiative: workunderinitiative2,
			disciplinaryaction: disciplinaryaction2,
			disciplinaryactiondetails: disciplinaryactiondetails2,
			investigations: investigations2,
			investigationsdetails: investigationsdetails2,
			vulnerablepeople: vulnerablepeople2,
			vulnerablepeopledetails: vulnerablepeopledetails2,
			criminaloffences: criminaloffence2,
			criminaloffencedetails: criminaloffencedetails2,
			additionalcomments: additionalcomments2,
			campanystamp: campanystamp2,
			referenceverifydate: referenceverifydate2,
			// referenceverifynotes: referenceverifynotes2
		} = form_reference2 ? form_reference2 : {};

		const reference_details2 = form_reference2;
		/* if (path_name === Canditates_URL || path_name === Referee_URL || path_name === Summary_URL) {
			  this.setState({
				refemailsend1: form_data.reference1 && form_data.reference1.firstrefemail,
				refemailsend2: form_data.reference2 && form_data.reference2.secondrefemail,
				refereename1: `${form_data.reference1.firstreffirstname}${form_data.reference1.firstreflastname}`,
				refereename2: `${form_data.reference2.secondreffirstname}${form_data.reference2.secondreflastname}`
			  });
			}*/
		const externalCloseBtn = (
			<button
				className="close fileview_close"
				onClick={() => this.FileView("")}
			>
				<i className="fa fa-close fa-4x btn btn-success" aria-hidden="true" />
			</button>
		);

		const { mainActiveTab, activeTab, int } = this.state;

		return (
			<div className="candidate-main">
				<Fragment>
					<Breadcrumb title="View Candidate" parent="Candidates" />
					{int ? <CandidateStats /> : null}
					<div className="mar-top"></div>
					<div className="card main-space">
						<div className="row mb-1">

							<div className="dotted-click">
								<div className=" bts-ranges arrange-details" >
									<button
										type="button"
										onClick={this.openAllAccordian}
										className="btn cand-btns"
									>
										{this.state.open ? (
											<>
												<img src={closeall} alt="edit" />
                        Close all
                      </>
										) : (
											<>
												<img src={openall} alt="edit" />
                        Open all
                      </>
										)}
									</button>
								</div>

								<UncontrolledDropdown
								// onClick={(e) =>
								// this.onFunval(e, item._id)
								//      }
								>
									<DropdownToggle className="btn-sm btn-info">
										<a data-toggle="dropdown"><span className="threedots"></span></a>
									</DropdownToggle>
									<DropdownMenu>
										<div className="consider-ranges">
											<button
												type="button"
												onClick={this.editpage}
												className="btn cand-btns"
											>
												<img src={editdash} alt="edit" /> Edit
                      </button>
											<button
												type="button"
												className="btn cand-btns"
												onClick={this.download_pdf}
											>
												<img src={download} alt="download" />
                        Download
                      </button>
										</div>
									</DropdownMenu>
								</UncontrolledDropdown>

							</div>
						</div>


						<div className="req-views">
							<div className="profile-stru">
								<div className="col-md-6">
									<div className="product-page-details img-ciir">
										<img
											width="150px"
											height="150px"
											src={
												String(avatar).length > 0
													? `${NodeURL}/${avatar}`
													: user
											}
											alt="Profile"
										/>
									</div>
								</div>
								<div className="col-md-6 multi-stu">
									<h5>{`${this.state.firstname &&
										this.state.firstname.length > 0 &&
										String(this.state.firstname) !== String(undefined)
										? this.state.firstname
										: firstname &&
											firstname.length > 0 &&
											String(firstname) !== String(undefined)
											? firstname
											: ""
										}  ${this.state.lastname &&
											this.state.lastname.length > 0 &&
											String(this.state.lastname) !== String(undefined)
											? this.state.lastname
											: lastname &&
												lastname.length > 0 &&
												String(lastname) !== String(undefined)
												? lastname
												: ""
										}`}</h5>
									<h6>
										<img src={usernumber} alt="usernumber" />
										{unique_no &&
											unique_no.length > 0 &&
											String(unique_no) !== String(undefined)
											? unique_no
											: ""}
									</h6>
									<h6>
										<img src={portfolio} alt="portfolio" />
										{this.state.job_type_name &&
											this.state.job_type_name.length > 0 &&
											this.state.job_type_name.map((list, i) => (
												<>
													{list}
													{this.state.job_type_name.length - 1 === i ? "" : ", "}
												</>
											))}
									</h6>
									<h6>
										<img src={smartphone} alt="smartphone" />
										{/* {mobileno && mobileno.code}- */}
										{mobileno && mobileno.number ? append_zero(mobileno.number) : user_phone && CheckValue(user_phone.number) ? user_phone.number : null}
									</h6>
									<h6>
										<img src={mailsend} alt="mailsend" />
										{email &&
											String(email) !== String(undefined) &&
											email.length > 0
											? email
											: ""}
									</h6>
								</div>
							</div>

							<div className="view-adder">
								<ul className="categ-meyhods">
									<li>
										<h2>Your Personal Details</h2>

										<ul className="mds-lists">
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleP1 ? "active" : ""
																}`}
															onClick={() => this.onToggleAccordian("p1")}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleP1 ? "" : "active"
																}`}
															onClick={() => this.onToggleAccordian("p1")}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Personal Details 1
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleP1 ? "accordian" : ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Title <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{title === "mr"
																		? "Mr."
																		: title === "mrs"
																			? "Mrs."
																			: title === "miss"
																				? "Miss."
																				: title === "ms"
																					? "Ms."
																					: title === "dr"
																						? "Dr."
																						: title === "prof"
																							? "Prof."
																							: title === "rev"
																								? "Rev."
																								: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	First Name
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{firstname &&
																		String(firstname) !== String(undefined) &&
																		firstname.length > 0
																		? firstname
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Preferred Name
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{prefferedName &&
																		String(prefferedName) !==
																		String(undefined) &&
																		prefferedName.length > 0
																		? prefferedName
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Middle Name
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{middlename &&
																		String(middlename) !== String(undefined) &&
																		middlename.length > 0
																		? middlename
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Last Name
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{lastname &&
																		String(lastname) !== String(undefined) &&
																		lastname.length > 0
																		? lastname
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleP2 ? "active" : ""
																}`}
															onClick={() => this.onToggleAccordian("p2")}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleP2 ? "" : "active"
																}`}
															onClick={() => this.onToggleAccordian("p2")}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Personal Details 2
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleP2 ? "accordian" : ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Date Of Birth{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{this.state.dateofbirth}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Marital Status{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{martialStatus &&
																		String(martialStatus) !==
																		String(undefined) &&
																		martialStatus.length > 0
																		? martialStatus
																		: ""}
																</span>
															</p>
															{martialStatus === "Married" ? (
																<p>
																	<span className="left-views">
																		Date Of Marriage{" "}
																		<span className="col-qus">:</span>
																	</span>
																	<span className="right-views">
																		{this.state.dateofMarriage}
																	</span>
																</p>
															) : null}

															<p>
																<span className="left-views">
																	Nationality{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{nationality &&
																		String(nationality) !== String(undefined) &&
																		nationality.length > 0
																		? nationality
																		: ""}
																</span>
															</p>

															<p>
																<span className="left-views">
																	Religion <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{religion === "bhudist"
																		? "Bhudist"
																		: religion === "christian"
																			? "Christian"
																			: religion === "jewish"
																				? "Jewish"
																				: religion === "hindu"
																					? "Hindu"
																					: religion === "muslim"
																						? "Muslim"
																						: religion === "sikh"
																							? "Sikh"
																							: religion === "other"
																								? "Other"
																								: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianTogglePaddress
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordian("paddress")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianTogglePaddress
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordian("paddress")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Contact and Address Details
                          </h4>

													<div
														className={`req-levels  ${this.state.acoordianTogglePaddress
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Email <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{employee_email &&
																		employee_email.length > 0 &&
																		String(employee_email) !== String(undefined)
																		? employee_email
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Mobile No <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{/* {mobileno && mobileno.code}- */}
																	{mobileno && mobileno.number ? append_zero(mobileno.number) : user_phone && CheckValue(user_phone.number) ? user_phone.number : null}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Tel <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{homephone &&
																		String(homephone) !== String(undefined) &&
																		homephone.length > 0
																		? homephone
																		: ""}
																</span>
															</p>

															<p>
																<span className="left-views">
																	Street Address{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{streetAddress &&
																		String(streetAddress) !==
																		String(undefined) &&
																		streetAddress.length > 0
																		? streetAddress
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Address Line 2{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{addressline2 &&
																		String(addressline2) !==
																		String(undefined) &&
																		addressline2.length > 0
																		? addressline2
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	City <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{city &&
																		String(city) !== String(undefined) &&
																		city.length > 0
																		? city
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	State / Region{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{state &&
																		String(state) !== String(undefined) &&
																		state.length > 0
																		? state
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	ZIP / Postal Code{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{zip &&
																		String(zip) !== String(undefined) &&
																		zip.length > 0
																		? zip
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Country <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{country &&
																		String(country) !== String(undefined) &&
																		country.length > 0
																		? country
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Date moved to this address{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{this.state.dateMovedAddress === "" || String(this.state.dateMovedAddress) === String(undefined) || String(this.state.dateMovedAddress) === String(null) || String(this.state.dateMovedAddress) === String('Invalid date')
																		? ""
																		: moment(
																			this.state.dateMovedAddress
																		).format("DD-MM-YYYY")}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianTogglePwork
																? "active"
																: ""
																}`}
															onClick={() => this.onToggleAccordian("Pwork")}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianTogglePwork
																? ""
																: "active"
																}`}
															onClick={() => this.onToggleAccordian("Pwork")}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Work & Personal Details
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianTogglePwork
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Job Role
                                  <span className="col-qus">:</span>
																</span>
																{this.state.job_type_name &&
																	this.state.job_type_name.length > 0 &&
																	this.state.job_type_name.map((list, i) => (
																		<span className="right-views" key={i}>
																			{list}
																			{this.state.job_type_name.length - 1 ===
																				i
																				? ""
																				: ", "}
																		</span>
																	))}
															</p>
															<p>
																<span className="left-views">
																	Work Status
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{workStatus &&
																		workStatus.length > 0 &&
																		String(workStatus) !== String(undefined)
																		? workStatus
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianTogglePID ? "active" : ""
																}`}
															onClick={() => this.onToggleAccordian("PID")}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianTogglePID ? "" : "active"
																}`}
															onClick={() => this.onToggleAccordian("PID")}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            ID & Right to Work
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianTogglePID ? "accordian" : ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Document Type
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{this.state.documentType &&
																		String(this.state.documentType) !==
																		String(undefined) &&
																		this.state.documentType.length > 0
																		? this.state.documentType
																		: ""}
																</span>
															</p>
															{this.state.documentType !== "" &&
																this.state.documentType === "Passport" ? (
																<>
																	<p>
																		<span className="left-views">
																			Passport Details
                                      <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.Passportdetails &&
																				String(this.state.Passportdetails) !==
																				String(undefined) &&
																				this.state.Passportdetails.length > 0
																				? this.state.Passportdetails
																				: ""}
																		</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Document Number
                                      <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.documentNumber &&
																				String(this.state.documentNumber) !==
																				String(undefined) &&
																				this.state.documentNumber.length > 0
																				? this.state.documentNumber
																				: ""}
																		</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Expiry Date
                                      <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.docTypeExpiry &&
																				String(this.state.docTypeExpiry) !==
																				String(undefined) &&
																				this.state.docTypeExpiry.length > 0
																				? this.state.docTypeExpiry
																				: ""}
																		</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Country of Issue
                                      <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.countryOfIssue &&
																				String(this.state.countryOfIssue) !==
																				String(undefined) &&
																				this.state.countryOfIssue.length > 0
																				? this.state.countryOfIssue
																				: ""}
																		</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Visa Number/Ref
                                      <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.visaNumber &&
																				String(this.state.visaNumber) !==
																				String(undefined) &&
																				this.state.visaNumber.length > 0
																				? this.state.visaNumber
																				: ""}
																		</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Visa Country of Issue
                                      <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.visaCountryOfIssue &&
																				String(
																					this.state.visaCountryOfIssue
																				) !== String(undefined) &&
																				this.state.visaCountryOfIssue.length > 0
																				? this.state.visaCountryOfIssue
																				: ""}
																		</span>
																	</p>

																	<p>
																		<span className="left-views">
																			Visa Expiry Date
                                      <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.visaExpiry === "" || String(this.state.visaExpiry) === String(undefined) || String(this.state.visaExpiry) === String(null) || String(this.state.visaExpiry) === String('Invalid date')
																				? ""
																				: moment(
																					this.state.visaExpiry
																				).format("DD-MM-YYYY")}
																		</span>
																	</p>
																</>
															) : null}
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianTogglePAvailability
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordian("PAvailability")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianTogglePAvailability
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordian("PAvailability")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            General Availability
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianTogglePAvailability
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	When are you able to work?{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{work_mornings === "true"
																		? "Mornings ,"
																		: ""}
																	{work_evenings === "true"
																		? "Evenings ,"
																		: ""}
																	{work_afternoons === "true"
																		? "Afternoons ,"
																		: ""}
																	{work_occasional === "true"
																		? "Occasional Weeks ,"
																		: ""}
																	{work_fulltime === "true"
																		? "Full Time ,"
																		: ""}
																	{work_parttime === "true"
																		? "Part Time ,"
																		: ""}
																	{work_nights === "true" ? "Nights ," : ""}
																	{work_weekends === "true"
																		? "Weekends ,"
																		: ""}
																	{work_anytime === "true" ? "Anytime ," : ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Would you be willing to work at short
                                  notice? <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{shortnotice === "yes"
																		? "Yes"
																		: shortnotice === "no"
																			? "No"
																			: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	What is the Earliest Date you can start
                                  work? <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{this.state.availablestartdate === "" || String(this.state.availablestartdate) === String(undefined) || String(this.state.availablestartdate) === String(null) || String(this.state.availablestartdate) === String('Invalid date')
																		? ""
																		: moment(
																			this.state.availablestartdate
																		).format("DD-MM-YYYY")}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Do you have any commitments that reduce your
                                  flexibility to work{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{reduceworkflexibility === "yes"
																		? "Yes"
																		: reduceworkflexibility === "no"
																			? "No"
																			: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	If yes, please state
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{workstate &&
																		String(workstate) !== String(undefined) &&
																		workstate.length > 0
																		? workstate
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianTogglePDriving
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordian("PDriving")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianTogglePDriving
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordian("PDriving")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Driving License Details
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianTogglePDriving
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Do you have a driving License?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{drivinglicence && drivinglicence.length > 0
																		? drivinglicence === "yes"
																			? "YES"
																			: "NO"
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	License Number
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{drivers_licence &&
																		drivers_licence.licence_number &&
																		drivers_licence.licence_number.length > 0 &&
																		String(drivers_licence.licence_number) !==
																		String(undefined)
																		? drivers_licence.licence_number
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Country of Issue
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{drivers_licence &&
																		drivers_licence.country_of_issue &&
																		drivers_licence.country_of_issue.length >
																		0 &&
																		String(drivers_licence.country_of_issue) !==
																		String(undefined)
																		? drivers_licence.country_of_issue
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	License Expiry Date
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{drivers_licence &&
																		drivers_licence.licence_expiry &&
																		String(drivers_licence.licence_expiry) !==
																		String(undefined) &&
																		String(drivers_licence.licence_expiry) !==
																		String(null) &&
																		String(drivers_licence.licence_expiry) !==
																		String('Invalid date')
																		? moment(
																			drivers_licence.licence_expiry
																		).format("DD-MM-YYYY")
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	License Class
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{drivers_licence &&
																		drivers_licence.licence_class &&
																		drivers_licence.licence_class.length > 0 &&
																		String(drivers_licence.licence_class) !==
																		String(undefined)
																		? drivers_licence.licence_class
																		: ""}
																</span>
															</p>

															{this.state.documentType === "" ||
																this.state.documentType === "Passport" ||
																this.state.documentType ===
																"Residence Permit" ||
																this.state.documentType ===
																"Permanent Residence card" ||
																this.state.documentType ===
																"Biometric Card" ? null : (
																<p>
																	<span className="left-views">
																		Photo
                                    <span className="col-qus">:</span>
																	</span>
																	<span className="right-views">
																		{drivingPhotoID &&
																			String(drivingPhotoID) !==
																			String(undefined) &&
																			drivingPhotoID.length > 0
																			? drivingPhotoID.toUpperCase()
																			: ""}
																	</span>
																</p>
															)}
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleLanguage
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordian("Language")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleLanguage
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordian("Language")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Language
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleLanguage
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	English - Spoken{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{englishspoken === "fluent"
																		? "Fluent"
																		: englishspoken === "good"
																			? "Good"
																			: englishspoken === "fair"
																				? "Fair"
																				: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Other Languages Spoken{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{otherlanguage &&
																		otherlanguage.length > 0 &&
																		Array.isArray(otherlanguage)
																		? otherlanguage.map((item, i) => {
																			return (
																				<span
																					className="right-views"
																					key={i}
																				>
																					{item.value}
																				</span>
																			);
																		})
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	English - Written{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{englishwritten === "fluent"
																		? "Fluent"
																		: englishwritten === "good"
																			? "Good"
																			: englishwritten === "fair"
																				? "Fair"
																				: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleDbs ? "active" : ""
																}`}
															onClick={() => this.onToggleAccordian("Dbs")}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleDbs ? "" : "active"
																}`}
															onClick={() => this.onToggleAccordian("Dbs")}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            DBS Details
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleDbs ? "accordian" : ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Do you have a current DBS
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{this.state.currentDBS &&
																		String(this.state.currentDBS) !==
																		String(undefined) &&
																		this.state.currentDBS.length > 0
																		? this.state.currentDBS
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Certificate No
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{this.state.dbsCertificateNo &&
																		String(this.state.dbsCertificateNo) !==
																		String(undefined) &&
																		this.state.dbsCertificateNo.length > 0
																		? this.state.dbsCertificateNo
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Issue Date
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{this.state.dbsIssueDate}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianTogglekin ? "active" : ""
																}`}
															onClick={() => this.onToggleAccordian("kin")}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianTogglekin ? "" : "active"
																}`}
															onClick={() => this.onToggleAccordian("kin")}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Next of Kin Details
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianTogglekin ? "accordian" : ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	First Name{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kinfirstname &&
																		String(kinfirstname) !==
																		String(undefined) &&
																		kinfirstname.length > 0
																		? kinfirstname
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Last Name <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kinlastname &&
																		String(kinlastname) !== String(undefined) &&
																		kinlastname.length > 0
																		? kinlastname
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Relationship to you{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kinrelationship &&
																		String(kinrelationship) !==
																		String(undefined) &&
																		kinrelationship.length > 0
																		? kinrelationship
																		: ""}
																</span>
															</p>

															<p>
																<span className="left-views">
																	Home/Work Phone{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kinhomephone &&
																		String(kinhomephone) !==
																		String(undefined) &&
																		kinhomephone.length > 0
																		? kinhomephone
																		: ""}
																</span>
															</p>

															<p>
																<span className="left-views">
																	Mobile No <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{/* {kinmobileno && kinmobileno.code} -{" "} */}
																	{kinmobileno && kinmobileno.number ? append_zero(kinmobileno.number) : ''}
																</span>
															</p>

															<p>
																<span className="left-views">
																	Email <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kinemail &&
																		String(kinemail) !== String(undefined) &&
																		kinemail.length > 0
																		? kinemail
																		: ""}
																</span>
															</p>

															<p>
																<span className="left-views">
																	Street Address{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kinstreetAddress &&
																		String(kinstreetAddress) !==
																		String(undefined) &&
																		kinstreetAddress.length > 0
																		? kinstreetAddress
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Address Line 2{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kinaddressline2 &&
																		String(kinaddressline2) !==
																		String(undefined) &&
																		kinaddressline2.length > 0
																		? kinaddressline2
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	City <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kincity &&
																		String(kincity) !== String(undefined) &&
																		kincity.length > 0
																		? kincity
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	State / Region{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kinstate &&
																		String(kinstate) !== String(undefined) &&
																		kinstate.length > 0
																		? kinstate
																		: ""}
																</span>
															</p>

															<p>
																<span className="left-views">
																	ZIP / Postal Code{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kinzip &&
																		String(kinzip) !== String(undefined) &&
																		kinzip.length > 0
																		? kinzip
																		: ""}
																</span>
															</p>

															<p>
																<span className="left-views">
																	Country <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{kincountry &&
																		String(kincountry) !== String(undefined) &&
																		kincountry.length > 0
																		? kincountry
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>
										</ul>
									</li>

									<li>
										<h2>Employment & Education</h2>
										<ul className="mds-lists">
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleQualification
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianEmployment(
																	"Qualification"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleQualification
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianEmployment(
																	"Qualification"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Qualification
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleQualification
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															{this.state.education_qualification &&
																this.state.education_qualification.length >
																0 ? (
																this.state.education_qualification.map(
																	(item, i) => (
																		<>
																			<p key={i}>
																				<span className="left-views">
																					Course
                                          <span className="col-qus">:</span>
																				</span>

																				<span className="right-views">
																					{item.qualification_course}
																				</span>
																			</p>
																			<p>
																				<span className="left-views">
																					Level
                                          <span className="col-qus">:</span>
																				</span>

																				<span className="right-views">
																					{item.qualification_level}
																				</span>
																			</p>
																			<p>
																				<span className="left-views">
																					Title
                                          <span className="col-qus">:</span>
																				</span>

																				<span className="right-views">
																					{item.qualification_title}
																				</span>
																			</p>
																			<p>
																				<span className="left-views">
																					Date of Qualification
                                          <span className="col-qus">:</span>
																				</span>

																				<span className="right-views">
																					{(item.qualification_date === "" || String(item.qualification_date).length === 0 || String(item.qualification_date) === String(undefined)) || String(item.qualification_date) === String(null) || String(item.qualification_date) === String('Invalid date')
																						? ""
																						: moment(
																							item.qualification_date
																						).format("DD-MM-YYYY")}
																				</span>
																			</p>
																		</>
																	)
																)
															) : (
																<>
																	<p>
																		<span className="left-views">
																			Course
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Level
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Title
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Date of Qualification
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																</>
															)}
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleOtherQualification
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianEmployment(
																	"OtherQualification"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleOtherQualification
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianEmployment(
																	"OtherQualification"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Training & Other Course (Mandatory Training)
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleOtherQualification
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															{this.state.other_courses &&
																this.state.other_courses.length ? (
																this.state.other_courses.map((item, i) => (
																	<>
																		<p key={i}>
																			<span className="left-views">
																				Course
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{item.other_qualification_course}
																			</span>
																		</p>
																		<p>
																			<span className="left-views">
																				Level
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{item.other_qualification_level}
																			</span>
																		</p>
																		<p>
																			<span className="left-views">
																				Title
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{item.other_qualification_title}
																			</span>
																		</p>
																		<p>
																			<span className="left-views">
																				Date of Qualification
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{(item.other_qualification_date === '' || String(item.other_qualification_date).length === 0 || String(item.other_qualification_date) === String(undefined)) || String(item.other_qualification_date) === String(null) || String(item.other_qualification_date) === String('Invalid date')
																					? ''
																					:
																					moment(
																						item.other_qualification_date
																					).format("DD-MM-YYYY")}
																			</span>
																		</p>
																		<p>
																			<span className="left-views">
																			Expiry Date <span className="col-qus">:</span>
																			</span>
																			<span className="right-views">
																				{(item.other_qualification_date_expiry === '' || String(item.other_qualification_date_expiry).length === 0 || String(item.other_qualification_date_expiry) === String(undefined)) || String(item.other_qualification_date_expiry) === String(null) || String(item.other_qualification_date_expiry) === String('Invalid date')
																					? ''
																					:
																					moment(
																						item.other_qualification_date_expiry
																					).format("DD-MM-YYYY")}
																			</span>
																		</p>
																	</>
																))
															) : (
																<>
																	<p>
																		<span className="left-views">
																			Course
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Level
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Title
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Date of Qualification
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																</>
															)}
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleProfessional
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianEmployment(
																	"Professional"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleProfessional
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianEmployment(
																	"Professional"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Professional Body Memberships
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleProfessional
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">

															{/* <p>
                                <span className="left-views">
                                  Body <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {this.state.professionalBody &&
                                    String(this.state.professionalBody) !==
                                    String(undefined) &&
                                    this.state.professionalBody.length > 0
                                    ? this.state.professionalBody
                                    : ""}
                                </span>
                              </p>
                              <p>
                                <span className="left-views">
                                  PIN/REF<span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {this.state.pinRef &&
                                    String(this.state.pinRef) !==
                                    String(undefined) &&
                                    this.state.pinRef.length > 0
                                    ? this.state.pinRef
                                    : ""}
                                </span>
                              </p>

                              <p>
                                <span className="left-views">
                                  Expiry Date{" "}
                                  <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {this.state.professionalBodyExpiry}
                                </span>
                              </p> */}

															{this.state.professional_Body &&
																this.state.professional_Body.length ? (
																this.state.professional_Body.map((item, i) => (
																	<>
																		<p key={i}>
																			<span className="left-views">
																				Body
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{item.professionalBody}
																			</span>
																		</p>
																		<p>
																			<span className="left-views">
																				PIN/REF
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{item.pinRef}
																			</span>
																		</p>
																		<p>
																			<span className="left-views">
																				Expiry Date
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{(item.professionalBodyExpiry === "" || String(item.professionalBodyExpiry).length === 0 || String(item.professionalBodyExpiry) === String(undefined)) || String(item.professionalBodyExpiry) === String(null) || String(item.professionalBodyExpiry) === String('Invalid date')
																					? ""
																					: moment(
																						item.professionalBodyExpiry
																					).format("DD-MM-YYYY")}
																			</span>
																		</p>
																	</>
																))
															) : (
																<>
																	<p>
																		<span className="left-views">
																			Body
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			PIN/REF
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Expiry Date
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																</>
															)}

														</div>
													</div>
												</div>
											</li>
										</ul>
									</li>

									<li>
										<h2> Skills & Work History</h2>
										<ul className="mds-lists">
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleSkills
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianEmployment("Skills")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleSkills
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianEmployment("Skills")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Qualification
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleSkills
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															{this.state.work_exp &&
																this.state.work_exp.length > 0 ? (
																this.state.work_exp.map((item, i) => (
																	<>
																		<p key={i}>
																			<span className="left-views">
																				Work Title
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{item.work_title}
																			</span>
																		</p>
																		<p>
																			<span className="left-views">
																				Employer
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{item.employer ? item.employer : ''}
																			</span>
																		</p>
																		<p>
																			<span className="left-views">
																				From Date
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{item.work_from_date === "" || String(item.work_from_date) === String(undefined) || String(item.work_from_date) === String(null) || String(item.work_from_date) === String('Invalid date') ? '' :
																					moment(item.work_from_date).format(
																						"DD-MM-YYYY"
																					)}
																			</span>
																		</p>
																		<p>
																			<span className="left-views">
																				To Date
                                        <span className="col-qus">:</span>
																			</span>

																			<span className="right-views">
																				{item.work_to_date === "" || String(item.work_to_date) === String(undefined) || String(item.work_to_date) === String(null) || String(item.work_to_date) === String('Invalid date') ? '' :
																					moment(item.work_to_date).format(
																						"DD-MM-YYYY"
																					)}
																			</span>
																		</p>
																	</>
																))
															) : (
																<>
																	<p>
																		<span className="left-views">
																			Work Title
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Employer
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			From Date
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			To Date
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																	<p>
																		<span className="left-views">
																			Date of Qualification
                                      <span className="col-qus">:</span>
																		</span>

																		<span className="right-views">-</span>
																	</p>
																</>
															)}

															<p>
																<span className="left-views">
																	Provide Details of gaps if any
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{this.state.skillProvideDetails}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>
										</ul>
									</li>

									<li>
										<h2> Declaration and Terms</h2>
										<ul className="mds-lists">
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleWorkingTime
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"WorkingTime"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleWorkingTime
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"WorkingTime"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Working Time Regulations
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleWorkingTime
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																The Working Time Regulations of 1998 state
																that a Temporary Worker shall not work on an
																Assignment with a client in excess of the
																Working Week unless they agree in writing that
																this limit should not apply.
                                <br></br>
                                The Temporary worker, by signing the
                                declaration below, agrees that the Working
                                Week shall not apply to their Assignments.
                                <br></br>
                                The Temporary Worker can end this Agreement at
                                anytime by giving the Employment Business 14
                                days notice in writing. After the 14 day
                                notice period has expired the Working Week
                                shall apply immediately.<br></br>
                                It should be noted, that any notice ending
                                this Agreement does not mean that a Temporary
                                Worker has ended an Assignment with a Client.
                                <br></br>
                                In addition, I also consent to work in excess
                                of the maximum number of hours permitted to
                                work at night under the directive. Please note
                                you are under no obligation to sign either
                                declaration.
                                <br></br>
                                These laws are governed by English Law and are
                                subject to the jurisdiction of the English
                                Courts.
                              </p>
															<p>
																Date :{" "}
																{this.state.workTimeDate === "" || String(this.state.workTimeDate) === String(undefined) || String(this.state.workTimeDate) === String(null) || String(this.state.workTimeDate) === String('Invalid date')
																	? ""
																	: moment(this.state.workTimeDate).format(
																		"DD-MM-YYYY"
																	)}
															</p>

															<p>
																{workTimeSignature.includes("/") &&
																	String(workTimeSignature).length > 0 ? (
																	<>
																		<p> Signature :</p>
																		<img
																			width="180px"
																			height="180px"
																			src={`${NodeURL}/${workTimeSignature}`}
																			alt="Signature"
																		/>
																	</>
																) : workTimeSignature &&
																	workTimeSignature.length > 0 ? (
																	<>
																		<p> Signature : </p>
																		<h3
																			style={{
																				fontFamily:
																					"Brush Script MT, cursive",
																				fontWeight: "500",
																				fontSize: "70px",
																			}}
																		>
																			{workTimeSignature}
																		</h3>
																	</>
																) : null}
															</p>
														</div>
													</div>
												</div>
											</li>
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleHealthDeclaration
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"HealthDeclaration"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleHealthDeclaration
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"HealthDeclaration"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Health Declaration
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleHealthDeclaration
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																The purpose of the questionnaire and
																declaration is to establish whether you have
																any health problems that could affect your
																ability to undertake the duties of the post
																you have been offered or place you at any risk
																in the workplace. We may recommend adjustments
																or assistance as a result of this assessment
																to enable you to do the job. Our aim is to
																promote and maintain the health of all people
																at work. Before health clearance is given for
																employment you may be contacted by our
																nominated occupational health service provider
																and may need to be seen by an occupational
																health advisor or physician. Your record will
																be held on file for a short period of time and
																may be subject to audit.
                                <br></br>I {this.state.firstname}{" "}
																{this.state.lastname} consent to{" "}
																{this.state.company_name} releasing my health
                                and immunisation records for review to{" "}
																{this.state.company_name} qualified
                                Occupational Health Advisor.<br></br>I
                                understand that based on this review I may be
                                required to undergo a medical examination to
                                establish my fitness for work.<br></br>I agree
                                to immediately inform{" "}
																{this.state.company_name} should my general
                                condition of health change. I will inform{" "}
																{this.state.company_name} immediately if I
                                discover that I am pregnant. I understand that
                                withholding information or giving false
                                answers may lead to dismissal :{" "}
																{this.state.acceptHealthDeclaration === "true"
																	? "YES"
																	: ""}
															</p>
															<p>
																Date :{" "}
																{this.state.HealthDeclarationDate === "" || String(this.state.HealthDeclarationDate) === String(undefined) || String(this.state.HealthDeclarationDate) === String(null) || String(this.state.HealthDeclarationDate) === String('Invalid date')
																	? ""
																	: moment(
																		this.state.HealthDeclarationDate
																	).format("DD-MM-YYYY")}
															</p>
														</div>
													</div>
												</div>
											</li>
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianTogglePersonalDeclaration
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"PersonalDeclaration"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianTogglePersonalDeclaration
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"PersonalDeclaration"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Personal Declaration
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianTogglePersonalDeclaration
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																Thereby confirm that the information provided
																on my application is correct and true to the
																best of my knowledge and that I have not
																withheld any information that should be taken
																into account when offering me work.
                                <br></br>I understand that providing false or
                                inaccurate information may result in the
                                termination of any placement.<br></br>I agree
                                that I will make best endeavours to make
                                myself aware of the Health & Safety procedures
                                for each client I am assigned to.
                                <br></br>I confirm that I have read and
                                understood the Terms of Engagement and the
                                terms of the declaration and agree to be bound
                                by them.<br></br>
																{this.state.company_name} retains the right to
                                hold this application and any other data
                                required to process this application (whether
                                in the UK, European Union or elsewhere) and
                                keep for as long as necessary in line with the
                                data protection act.
                                <br></br>I consent to{" "}
																{this.state.company_name} checking the details
                                I have provided against the various data
                                sources in order to verify my identity and
                                process the application. These details may be
                                recorded and used to assist other scrambled
                                organisations for identity verification
                                purposes such as the DBS and regulatory bodies
                                such as NMC or GSCC :{" "}
																{this.state.acceptPersonalDeclaration ===
																	"true"
																	? "YES"
																	: ""}
															</p>
															<p>
																Date :{" "}
																{this.state.PersonalDeclarationDate === "" || String(this.state.PersonalDeclarationDate) === String(undefined) || String(this.state.PersonalDeclarationDate) === String(null) || String(this.state.PersonalDeclarationDate) === String('Invalid date')
																	? ""
																	: moment(
																		this.state.PersonalDeclarationDate
																	).format("DD-MM-YYYY")}
															</p>
														</div>
													</div>
												</div>
											</li>
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleConfidentiality
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"Confidentiality"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleConfidentiality
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"Confidentiality"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Confidentiality
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleConfidentiality
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																I hereby declare that at no time will I
																divulge to any person, nor use for my own or
																any other person’s benefit, any confidential
                                information in relation to the Client or the{" "}
																{this.state.company_name} or in relation to
                                any of their employees, business affairs,
                                transactions or finances which I may acquire
                                during the term of my agreement with the{" "}
																{this.state.company_name} under the Terms of
                                Engagement :{" "}
																{this.state.acceptConfidentiality === "true"
																	? "YES"
																	: ""}
															</p>
															<p>
																Date :{" "}
																{this.state.ConfidentialityDate === "" || String(this.state.ConfidentialityDate) === String(undefined) || String(this.state.ConfidentialityDate) === String(null) || String(this.state.ConfidentialityDate) === String('Invalid date')
																	? ""
																	: moment(
																		this.state.ConfidentialityDate
																	).format("DD-MM-YYYY")}
															</p>
														</div>
													</div>
												</div>
											</li>
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleDBSDeclaration
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"DBSDeclaration"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleDBSDeclaration
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"DBSDeclaration"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Disclosure Barring Service (DBS)
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleDBSDeclaration
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																The Disclosure and Barring Service (DBS –
																formerly Criminal Records Bureau CRB) is the
																executive agency of the Home Office
																responsible for conducting checks on criminal
																records. We are registered body for receipt of
																DBS disclosure information. NHS Trust and
																Private Sector hospitals and nursing homes
																insist on agencies making information
																recruitment decisions which require DBS checks
																to be made on all staff.
                                <br></br>
                                It is a condition of proceeding with your
                                application that you apply for a DBS
                                disclosure check. The disclosure will be
                                compared with the information given above and
                                any inconsistencies could invalidate your
                                application or lead to the cancellation of
                                your registration with us.<br></br>I confirm
                                the above is true and I understand that a DBS
                                check will be sought in the event of a
                                successful application. :{" "}
																{this.state.dbsAccept === "true" ? "YES" : ""}
															</p>
															<p>
																Date :{" "}
																{this.state.dbsAcceptDate === "" || String(this.state.dbsAcceptDate) === String(undefined) || String(this.state.dbsAcceptDate) === String(null) || String(this.state.dbsAcceptDate) === String('Invalid date')
																	? ""
																	: moment(this.state.dbsAcceptDate).format(
																		"DD-MM-YYYY"
																	)}
															</p>
														</div>
													</div>
												</div>
											</li>

											{/* <li>
                        <div className="common-added">
                          <h4>
                            <span
                              className={`accfun ${this.state.acoordianToggleMedical
                                ? "active"
                                : ""
                                }`}
                              onClick={() =>
                                this.onToggleAccordianDeclaration("Medical")
                              }
                            >
                              <i class="fa fa-minus" aria-hidden="true"></i>
                            </span>
                            <span
                              className={`accfun ${this.state.acoordianToggleMedical
                                ? ""
                                : "active"
                                }`}
                              onClick={() =>
                                this.onToggleAccordianDeclaration("Medical")
                              }
                            >
                              <i class="fa fa-plus" aria-hidden="true"></i>
                            </span>
                              Medical History
                            </h4>
                          <div
                            className={`req-levels  ${this.state.acoordianToggleMedical
                              ? "accordian"
                              : ""
                              }`}
                          >
                            <div className="req-bor">
                              <p>
                                <span className="left-views">
                                  Do you have any
                                  illness/impairment/disability (physical or
                                    psychological) which may affect your work?{" "}
                                  <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {medicalillness &&
                                    String(medicalillness) !==
                                    String(undefined) &&
                                    medicalillness.length > 0
                                    ? medicalillness.toUpperCase()
                                    : ""}
                                </span>
                              </p>
                              <p>
                                <span className="left-views">
                                  Have you ever had any
                                  illness/impairment/disability which may have
                                  been caused or made worse by your work?
                                    <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {medicalillnesscaused &&
                                    String(medicalillnesscaused) !==
                                    String(undefined) &&
                                    medicalillnesscaused.length > 0
                                    ? medicalillnesscaused.toUpperCase()
                                    : ""}
                                </span>
                              </p>
                              <p>
                                <span className="left-views">
                                  Are you having, or waiting for treatment
                                  (including medication) or investigations at
                                  present? If your answer is yes, please
                                  provide further details of the condition,
                                  treatment and dates?
                                    <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {treatment &&
                                    String(treatment) !== String(undefined) &&
                                    treatment.length > 0
                                    ? treatment.toUpperCase()
                                    : ""}
                                </span>
                              </p>
                              <p>
                                <span className="left-views">
                                  Do you think you may need any adjustments or
                                  assistance to help you to do the job?
                                    <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {needanyadjustments &&
                                    String(needanyadjustments) !==
                                    String(undefined) &&
                                    needanyadjustments.length > 0
                                    ? needanyadjustments.toUpperCase()
                                    : ""}
                                </span>
                              </p>

                              {needanyadjustments &&
                                needanyadjustments.toUpperCase() === "YES" ? (
                                  <p>
                                    <span className="left-views">
                                      Notes
                                      <span className="col-qus">:</span>
                                    </span>
                                    <span className="right-views">
                                      {needanyadjustmentsnotes &&
                                        String(needanyadjustmentsnotes) !==
                                        String(undefined) &&
                                        needanyadjustmentsnotes.length > 0
                                        ? needanyadjustmentsnotes
                                        : ""}
                                    </span>
                                  </p>
                                ) : null}
                            </div>
                          </div>
                        </div>
                      </li>

                      <li>
                        <div className="common-added">
                          <h4>
                            <span
                              className={`accfun ${this.state.acoordianToggleTuberculosis
                                ? "active"
                                : ""
                                }`}
                              onClick={() =>
                                this.onToggleAccordianDeclaration(
                                  "Tuberculosis"
                                )
                              }
                            >
                              <i class="fa fa-minus" aria-hidden="true"></i>
                            </span>
                            <span
                              className={`accfun ${this.state.acoordianToggleTuberculosis
                                ? ""
                                : "active"
                                }`}
                              onClick={() =>
                                this.onToggleAccordianDeclaration(
                                  "Tuberculosis"
                                )
                              }
                            >
                              <i class="fa fa-plus" aria-hidden="true"></i>
                            </span>
                              Tuberculosis
                            </h4>
                          <div
                            className={`req-levels  ${this.state.acoordianToggleTuberculosis
                              ? "accordian"
                              : ""
                              }`}
                          >
                            <div className="req-bor">
                              <p>
                                {" "}
                                  Clinical diagnosis and management of
                                  tuberculosis, and measures for its prevention
                                  and control (NICE 2006){" "}
                              </p>
                              <p>
                                <span className="left-views">
                                  Have you lived continuously in the UK for
                                  the last 5 years
                                    <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {livedUK &&
                                    String(livedUK) !== String(undefined) &&
                                    livedUK.length > 0
                                    ? livedUK.toUpperCase()
                                    : ""}
                                </span>
                              </p>{" "}
                              {livedUK && livedUK.toUpperCase() === "NO" ? (
                                <p>
                                  <span className="left-views">
                                    Please list all the countries that you
                                    have lived in over the last 5 years
                                      <span className="col-qus">:</span>
                                  </span>
                                  <span className="right-views">
                                    {livedUKnotes &&
                                      String(livedUKnotes) !==
                                      String(undefined) &&
                                      livedUKnotes.length > 0
                                      ? livedUKnotes
                                      : ""}
                                  </span>
                                </p>
                              ) : null}
                              <p>
                                <span className="left-views">
                                  Have you had a BCG vaccination in relation
                                  to Tuberculosis?
                                    <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {BCGvaccination &&
                                    String(BCGvaccination) !==
                                    String(undefined) &&
                                    BCGvaccination.length > 0
                                    ? BCGvaccination.toUpperCase()
                                    : ""}
                                </span>
                              </p>{" "}
                              {BCGvaccination &&
                                BCGvaccination.toUpperCase() === "YES" ? (
                                  <p>
                                    <span className="left-views">
                                      Date
                                      <span className="col-qus">:</span>
                                    </span>
                                    <span className="right-views">
                                      {moment(BCGvaccinationdate).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </span>
                                  </p>
                                ) : null}
                              <p>
                                <span className="left-views">
                                  A cough which has lasted for more than 3
                                  weeks
                                    <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {cough &&
                                    String(cough) !== String(undefined) &&
                                    cough.length > 0
                                    ? cough.toUpperCase()
                                    : ""}
                                </span>
                              </p>
                              <p>
                                <span className="left-views">
                                  Unexplained weight loss
                                    <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {weightloss &&
                                    String(weightloss) !== String(undefined) &&
                                    weightloss.length > 0
                                    ? weightloss.toUpperCase()
                                    : ""}
                                </span>
                              </p>
                              <p>
                                <span className="left-views">
                                  Unexplained fever
                                    <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {fever &&
                                    String(fever) !== String(undefined) &&
                                    fever.length > 0
                                    ? fever.toUpperCase()
                                    : ""}
                                </span>
                              </p>
                              <p>
                                <span className="left-views">
                                  Have you had tuberculosis (TB) or been in
                                  recent contact with open TB
                                    <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {TB &&
                                    String(TB) !== String(undefined) &&
                                    TB.length > 0
                                    ? TB.toUpperCase()
                                    : ""}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </li> */}

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleCriminal
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration("Criminal")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleCriminal
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration("Criminal")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Rehabilation Of Offenders act 1974 & Criminal
                            Records
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleCriminal
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Have you been convicted of a criminal
																	offence?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{criminaloffence &&
																		String(criminaloffence) !==
																		String(undefined) &&
																		criminaloffence.length > 0
																		? criminaloffence.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Have you ever been cautioned or issued with
																	a formal warning for a criminal offence?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{criminalCautioned &&
																		String(criminalCautioned) !==
																		String(undefined) &&
																		criminalCautioned.length > 0
																		? criminalCautioned.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Do you have any spent or unspent criminal
																	convictions or cautions?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{criminalConvictions &&
																		String(criminalConvictions) !==
																		String(undefined) &&
																		criminalConvictions.length > 0
																		? criminalConvictions.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Have you ever been involved in court
																	proceedings?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{criminalCourt &&
																		String(criminalCourt) !==
																		String(undefined) &&
																		criminalCourt.length > 0
																		? criminalCourt.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Have you ever had disciplinary action taken
																	against you?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{criminalDisciplinaryAction &&
																		String(criminalDisciplinaryAction) !==
																		String(undefined) &&
																		criminalDisciplinaryAction.length > 0
																		? criminalDisciplinaryAction.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Please give any additional information which
																	you think may be relevant in support of your
																	application on below.
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{criminalAdditionalInformation &&
																		String(criminalAdditionalInformation) !==
																		String(undefined) &&
																		criminalAdditionalInformation.length > 0
																		? criminalAdditionalInformation.toUpperCase()
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleDBS ? "active" : ""
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration("DBS")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleDBS ? "" : "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration("DBS")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Disclosure Barring Service (DBS)
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleDBS ? "accordian" : ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	I confirm the above is true and I understand
																	that a DBS check will be sort in the event
																	of a successful application
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{dbsAccept &&
																		String(dbsAccept) !== String(undefined) &&
																		dbsAccept.length > 0
																		? dbsAccept.toUpperCase()
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleDISABILITY
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"DISABILITY"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleDISABILITY
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"DISABILITY"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Disability & Discrimination Act 1985
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleDISABILITY
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p className="font-views">
																{this.state.company_name} offers a guaranteed
                                interview to any applicant who considers
                                him/herself disabled and who meets the minimum
                                essential requirements for the post.
                              </p>
															<p>
																<span className="left-views">
																	Are you registered disabled?:
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{registereddisabled &&
																		String(registereddisabled) !==
																		String(undefined) &&
																		registereddisabled.length > 0
																		? registereddisabled.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Please give details
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{disableRegisteredDetails &&
																		String(disableRegisteredDetails) !==
																		String(undefined) &&
																		disableRegisteredDetails.length > 0
																		? disableRegisteredDetails.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Do you consider yourself to be disabled
																	under the Disability and Discrimination Act?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{disableAct &&
																		String(disableAct) !== String(undefined) &&
																		disableAct.length > 0
																		? disableAct.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Please give details
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{disableActDetails &&
																		String(disableActDetails) !==
																		String(undefined) &&
																		disableActDetails.length > 0
																		? disableActDetails.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Are there any adjustments that you think we
																	would make to overcome a disability in
																	relation to the essential requirements of
																	this Job.
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{disableOverCome &&
																		String(disableOverCome) !==
																		String(undefined) &&
																		disableOverCome.length > 0
																		? disableOverCome.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Please give details
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{disableOverComeDetails &&
																		String(disableOverComeDetails) !==
																		String(undefined) &&
																		disableOverComeDetails.length > 0
																		? disableOverComeDetails.toUpperCase()
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleDirectives
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"Directives"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleDirectives
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDeclaration(
																	"Directives"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Registration form Declaration{" "}
													</h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleDirectives
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																I declare that by signing this form I am
																agreeing to declarations above . I am stating
																that I am legally entitled or allowed to work
																in the United Kingdom, with or without
																necessary permission from the Home Office or
																any other relevant authority. If I have
																secured permission to work, I have included
																copies of all documentation. I also
																acknowledge that if it is found that I am
																working without the relevant permission, my
																employment will be terminated with immediate
																effect and all details passed to the relevant
                                authorities.<br></br>I agree that{" "}
																{this.state.company_name} retains the right to
                                hold this registration form and any other data
                                required to process it and pass onto any
                                authorised third party and the details held
                                within. I also agree to use all reasonable
                                efforts to assist to comply with the Data
                                Protection Act 2018.<br></br>
                                In addition, I confirm that that all the
                                information provided is true and accurate and
                                that I have received and agree to{" "}
																{this.state.company_name} Recruitment terms of
                                engagement and Staff Handbook.
                              </p>
															<p>
																I declare that all information given in this
																registration form is to the best of my
																knowledge complete and accurate in all
																respects and that I am eligible to work in the
                                UK :{" "}
																{declarationAccept === "true" &&
																	String(declarationAccept) !==
																	String(undefined) &&
																	declarationAccept.length > 0
																	? "YES"
																	: ""}
															</p>
															<p>Date : {this.state.declarationAcceptDate}</p>

															<p>
																{signature.includes("/") &&
																	String(signature).length > 0 ? (
																	<>
																		<h5 className="mt-20"> Signature </h5>
																		<img
																			width="180px"
																			height="180px"
																			src={`${NodeURL}/${signature}`}
																			alt="Signature"
																		/>
																	</>
																) : signature && signature.length > 0 ? (
																	<>
																		<h5 className="mt-20"> Signature : </h5>
																		<h3
																			style={{
																				fontFamily:
																					"Brush Script MT, cursive",
																				fontWeight: "500",
																				fontSize: "70px",
																			}}
																		>
																			{signature}
																		</h3>
																	</>
																) : null}
															</p>
														</div>
													</div>
												</div>
											</li>
										</ul>
									</li>

									<li>
										<h2> Documents </h2>
										<ul className="mds-lists">
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianTogglePassport
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments("Passport")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianTogglePassport
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments("Passport")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Passport
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianTogglePassport
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															{this.state.passportdocs.length > 0 &&
																[...this.state.passportdocs].filter(e => (CheckValue(e.path) && String(e.path).includes('uploads'))).map((list, i) => (
																	<div className="documentlist" key={i}>
																		<div className="document-custom">
																			<img
																				src={`${pdf}`}
																				alt="files"
																				className="fileviewimg"
																				id={`passportdocs${i}`}
																				onClick={() => this.FileView(list.path)}
																			/>
																			<UncontrolledTooltip
																				placement="bottom"
																				target={`passportdocs${i}`}
																			>
																				View Document
                                      </UncontrolledTooltip>
																			<span className="documents-name">
																				{" "}
																				{list && list.name}{" "}
																			</span>
																			<span className="download-document">
																				<img src={download} alt="download" id={`passportdownload${i}`} onClick={(e) => { this.FileDownloader(list.path, `passport${i}.${String(list.path).split('.').pop()}`) }} />
																			</span>
																			<UncontrolledTooltip
																				placement="bottom"
																				target={`passportdownload${i}`}
																			>
																				Download
                                      </UncontrolledTooltip>
																		</div>
																	</div>
																))}
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleVisa ? "active" : ""
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments("Visa")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleVisa ? "" : "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments("Visa")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Visa
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleVisa
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															{this.state.visadocs.length > 0 &&
																[...this.state.visadocs].filter(e => (CheckValue(e.path) && String(e.path).includes('uploads'))).map((list, i) => (
																	<div className="documentlist" key={i}>
																		<div className="document-custom">
																			<img
																				src={`${pdf}`}
																				alt="files"
																				className="fileviewimg"
																				id={`visadocs${i}`}
																				onClick={() => this.FileView(list.path)}
																			/>
																			<UncontrolledTooltip
																				placement="bottom"
																				target={`visadocs${i}`}
																			>
																				View Document
                                      </UncontrolledTooltip>
																			<span className="documents-name">
																				{" "}
																				{list && list.name}{" "}
																			</span>
																			<span className="download-document">
																				<img src={download} alt="download" id={`visadocsdownload${i}`} onClick={(e) => { this.FileDownloader(list.path, `visa${i}.${String(list.path).split('.').pop()}`) }} />
																			</span>
																			<UncontrolledTooltip
																				placement="bottom"
																				target={`visadocsdownload${i}`}
																			>  Download</UncontrolledTooltip>
																		</div>
																	</div>
																))}
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleDriving
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments("Driving")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleDriving
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments("Driving")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Driving License Details
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleDriving
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															{this.state.drivingdocs.length > 0 &&
																[...this.state.drivingdocs].filter(e => (CheckValue(e.path) && String(e.path).includes('uploads'))).map((list, i) => (
																	<div className="documentlist" key={i}>
																		<div className="document-custom">
																			<img
																				src={`${pdf}`}
																				alt="files"
																				className="fileviewimg"
																				id={`drivingdocs${i}`}
																				onClick={() => this.FileView(list.path)}
																			/>
																			<UncontrolledTooltip
																				placement="bottom"
																				target={`drivingdocs${i}`}
																			>
																				View Document
                                      </UncontrolledTooltip>
																			<span className="documents-name">
																				{" "}
																				{list && list.name}{" "}
																			</span>
																			<span className="download-document">
																				<img src={download} alt="download" id={`drivingdocsdownload${i}`} onClick={(e) => { this.FileDownloader(list.path, `driving${i}.${String(list.path).split('.').pop()}`) }} />
																			</span>
																			<UncontrolledTooltip
																				placement="bottom"
																				target={`drivingdocsdownload${i}`}
																			>  Download</UncontrolledTooltip>
																		</div>
																	</div>
																))}
														</div>
													</div>
												</div>
											</li>

											{/* <li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleEducation
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments("Education")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleEducation
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments("Education")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Education Qualifications
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleEducation
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															{this.state.educationdocs.length > 0 &&
																[...this.state.educationdocs].filter(e => (CheckValue(e.path) && String(e.path).includes('uploads'))).map((list, i) => (
																	<div className="documentlist" key={i}>
																		<div className="document-custom">
																			<img
																				src={`${pdf}`}
																				alt="files"
																				className="fileviewimg"
																				id={`educationdocs${i}`}
																				onClick={() => this.FileView(list.path)}
																			/>
																			<UncontrolledTooltip
																				placement="bottom"
																				target={`educationdocs${i}`}
																			>
																				View Document
                                      </UncontrolledTooltip>
																			<span className="documents-name">
																				{" "}
																				{list && list.course}{" "}
																			</span>
																			<span className="download-document">
																				<img src={download} alt="download" id={`educationdocsdownload${i}`} onClick={(e) => { this.FileDownloader(list.path, `education${i}.${String(list.path).split('.').pop()}`) }} />
																			</span>
																			<UncontrolledTooltip
																				placement="bottom"
																				target={`educationdocsdownload${i}`}
																			> Download</UncontrolledTooltip>
																		</div>
																	</div>
																))}
														</div>
													</div>
												</div>
											</li> */}

											{/* <li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleOtherEducation
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments(
																	"OtherEducation"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleOtherEducation
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments(
																	"OtherEducation"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Other Education
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleOtherEducation
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															{this.state.othereducationdocs.length > 0 &&
																[...this.state.othereducationdocs].filter(e => (CheckValue(e.path) && String(e.path).includes('uploads'))).map(
																	(list, i) => (
																		<div className="documentlist" key={i}>
																			<div className="document-custom">
																				<img
																					src={`${pdf}`}
																					alt="files"
																					className="fileviewimg"
																					id={`othereducationdocs${i}`}
																					onClick={() =>
																						this.FileView(list.path)
																					}
																				/>
																				<UncontrolledTooltip
																					placement="bottom"
																					target={`othereducationdocs${i}`}
																				>
																					View Document
                                        </UncontrolledTooltip>
																				<span className="documents-name">
																					{" "}
																					{list && list.course}{" "}
																				</span>
																				<span className="download-document">
																					<img src={download} alt="download" id={`othereducationdocsdownload${i}`} onClick={(e) => { this.FileDownloader(list.path, `othereducation${i}.${String(list.path).split('.').pop()}`) }} />
																				</span>
																				<UncontrolledTooltip
																					placement="bottom"
																					target={`othereducationdocsdownload${i}`}
																				> Download</UncontrolledTooltip>
																			</div>
																		</div>
																	)
																)}
														</div>
													</div>
												</div>
											</li> */}

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleOtherDocuments
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments("Documents")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleOtherDocuments
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianDocuments("Documents")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Other Documents
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleOtherDocuments
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															{this.state.documents.length > 0 &&
																[...this.state.documents].filter(e => (CheckValue(e.upload_doc) && String(e.upload_doc).includes('uploads'))).map((list, i) => (
																	<div className="documentlist" key={i}>
																		<div className="document-custom">
																			<img
																				src={pdf}
																				alt="files"
																				className="fileviewimg"
																				id={`fileview1${i}`}
																				onClick={() =>
																					this.FileView(list.upload_doc)
																				}
																			/>
																			<UncontrolledTooltip
																				placement="bottom"
																				target={`fileview1${i}`}
																			>
																				View Document
                                      </UncontrolledTooltip>
																			<span className="documents-name">
																				{" "}
																				{list && list.document_title}{" "}
																			</span>
																			<span className="download-document">
																				<img src={download} alt="download" id={`fileview1download${i}`} onClick={(e) => { this.FileDownloader(list.upload_doc, `otherdocs${i}.${String(list.upload_doc).split('.').pop()}`) }} />
																			</span>
																			<UncontrolledTooltip
																				placement="bottom"
																				target={`fileview1download${i}`}
																			>  Download</UncontrolledTooltip>
																		</div>
																	</div>
																))}
														</div>
													</div>
												</div>
											</li>
										</ul>
									</li>

									<li>
										<h2> Your references </h2>
										<ul className="mds-lists">
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleRef1 ? "active" : ""
																}`}
															onClick={() =>
																this.onToggleAccordianReference("Ref1")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleRef1 ? "" : "active"
																}`}
															onClick={() =>
																this.onToggleAccordianReference("Ref1")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Reference 1
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleRef1
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	First Name{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{firstreffirstname &&
																		String(firstreffirstname) !==
																		String(undefined) &&
																		firstreffirstname.length > 0
																		? firstreffirstname
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Last Name <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{firstreflastname &&
																		String(firstreflastname) !==
																		String(undefined) &&
																		firstreflastname.length > 0
																		? firstreflastname
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Mobile No <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{/* {firstrefphone && firstrefphone.code} -{" "} */}
																	{firstrefphone && firstrefphone.number ? append_zero(firstrefphone.number) : ''}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Email <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{firstrefemail &&
																		String(firstrefemail) !==
																		String(undefined) &&
																		firstrefemail.length > 0
																		? firstrefemail
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Street Address{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{firstrefstreetAddress &&
																		String(firstrefstreetAddress) !==
																		String(undefined) &&
																		firstrefstreetAddress.length > 0
																		? firstrefstreetAddress
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	City <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{firstrefcity &&
																		String(firstrefcity) !==
																		String(undefined) &&
																		firstrefcity.length > 0
																		? firstrefcity
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	State / Region{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{firstrefstate &&
																		String(firstrefstate) !==
																		String(undefined) &&
																		firstrefstate.length > 0
																		? firstrefstate
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	ZIP / Postal Code{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{firstrefzip &&
																		String(firstrefzip) !== String(undefined) &&
																		firstrefzip.length > 0
																		? firstrefzip
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Relationship{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{firstrefrelationship &&
																		String(firstrefrelationship) !==
																		String(undefined) &&
																		firstrefrelationship.length > 0
																		? firstrefrelationship
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleRef2 ? "active" : ""
																}`}
															onClick={() =>
																this.onToggleAccordianReference("Ref2")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleRef2 ? "" : "active"
																}`}
															onClick={() =>
																this.onToggleAccordianReference("Ref2")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Reference 2
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleRef2
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	First Name{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{secondreffirstname &&
																		String(secondreffirstname) !==
																		String(undefined) &&
																		secondreffirstname.length > 0
																		? secondreffirstname
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Last Name <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{secondreflastname &&
																		String(secondreflastname) !==
																		String(undefined) &&
																		secondreflastname.length > 0
																		? secondreflastname
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Mobile No <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{/* {secondrefphone && secondrefphone.code} -{" "} */}
																	{secondrefphone && secondrefphone.number ? append_zero(secondrefphone.number) : ''}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Email <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{secondrefemail &&
																		String(secondrefemail) !==
																		String(undefined) &&
																		secondrefemail.length > 0
																		? secondrefemail
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Street Address{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{secondrefstreetAddress &&
																		String(secondrefstreetAddress) !==
																		String(undefined) &&
																		secondrefstreetAddress.length > 0
																		? secondrefstreetAddress
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	City <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{secondrefcity &&
																		String(secondrefcity) !==
																		String(undefined) &&
																		secondrefcity.length > 0
																		? secondrefcity
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	State / Region{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{secondrefstate &&
																		String(secondrefstate) !==
																		String(undefined) &&
																		secondrefstate.length > 0
																		? secondrefstate
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	ZIP / Postal Code{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{secondrefzip &&
																		String(secondrefzip) !==
																		String(undefined) &&
																		secondrefzip.length > 0
																		? secondrefzip
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Relationship{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{secondrefrelationship &&
																		String(secondrefrelationship) !==
																		String(undefined) &&
																		secondrefrelationship.length > 0
																		? secondrefrelationship
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>
										</ul>
									</li>

									<li>
										<h2> Health Questionnaire </h2>
										<ul className="mds-lists">
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleHealth
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianHealth("Health")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleHealth
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianHealth("Health")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Health Declaration
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleHealth
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Do you or have ever suffered from long term
                                  illness? <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{sufferedlongtermillness &&
																		String(sufferedlongtermillness) !==
																		String(undefined) &&
																		sufferedlongtermillness.length > 0
																		? sufferedlongtermillness.toUpperCase()
																		: ""}
																</span>
															</p>
															{
																sufferedlongtermillness && String(sufferedlongtermillness) === 'yes' ?
																	<p>
																		<span className="left-views">Provided details <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.sufferedlongtermillness_notes && this.state.sufferedlongtermillness_notes.length > 0 && String(this.state.sufferedlongtermillness_notes) !== String(undefined) ? this.state.sufferedlongtermillness_notes : null}
																		</span>
																	</p>
																	: null
															}
															<p>
																<span className="left-views">
																	Have you ever required sick leave for a back
                                  or neck injury?:{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{leaveforneckinjury &&
																		String(leaveforneckinjury) !==
																		String(undefined) &&
																		leaveforneckinjury.length > 0
																		? leaveforneckinjury.toUpperCase()
																		: ""}
																</span>
															</p>
															{
																leaveforneckinjury && String(leaveforneckinjury) === 'yes' ?
																	<p>
																		<span className="left-views">Provided details <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.leaveforneckinjury_notes && this.state.leaveforneckinjury_notes.length > 0 && String(this.state.leaveforneckinjury_notes) !== String(undefined) ? this.state.leaveforneckinjury_notes : null}
																		</span>
																	</p>
																	: null
															}
															<p>
																<span className="left-views">
																	Do you suffer with any back or neck
                                  injuries? <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{neckinjuries &&
																		String(neckinjuries) !==
																		String(undefined) &&
																		neckinjuries.length > 0
																		? neckinjuries.toUpperCase()
																		: ""}
																</span>
															</p>
															{
																neckinjuries && String(neckinjuries) === 'yes' ?
																	<p>
																		<span className="left-views">Provided details <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.neckinjuries_notes && this.state.neckinjuries_notes.length > 0 && String(this.state.neckinjuries_notes) !== String(undefined) ? this.state.neckinjuries_notes : null}
																		</span>
																	</p>
																	: null
															}
															<p>
																<span className="left-views">
																	Have you been in contact with anyone who is
																	suffering from a contagious illness within
                                  the last six weeks?{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{sixweeksillness &&
																		String(sixweeksillness) !==
																		String(undefined) &&
																		sixweeksillness.length > 0
																		? sixweeksillness.toUpperCase()
																		: ""}
																</span>
															</p>
															{
																sixweeksillness && String(sixweeksillness) === 'yes' ?
																	<p>
																		<span className="left-views">Provided details <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.sixweeksillness_notes && this.state.sixweeksillness_notes.length > 0 && String(this.state.sixweeksillness_notes) !== String(undefined) ? this.state.sixweeksillness_notes : null}
																		</span>
																	</p>
																	: null
															}
															<p>
																<span className="left-views">
																	Do you suffer with a communicable disease?{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{communicabledisease &&
																		String(communicabledisease) !==
																		String(undefined) &&
																		communicabledisease.length > 0
																		? communicabledisease.toUpperCase()
																		: ""}
																</span>
															</p>
															{
																communicabledisease && String(communicabledisease) === 'yes' ?
																	<p>
																		<span className="left-views">Provided details <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.communicabledisease_notes && this.state.communicabledisease_notes.length > 0 && String(this.state.communicabledisease_notes) !== String(undefined) ? this.state.communicabledisease_notes : null}
																		</span>
																	</p>
																	: null
															}
															<p>
																<span className="left-views">
																	Are you currently receiving active medical
                                  attention?{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{medicalattention &&
																		String(medicalattention) !==
																		String(undefined) &&
																		medicalattention.length > 0
																		? medicalattention.toUpperCase()
																		: ""}
																</span>
															</p>
															{
																medicalattention && String(medicalattention) === 'yes' ?
																	<p>
																		<span className="left-views">Provided details{" "}
																			<span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{healthdeclarationdetails &&
																				String(healthdeclarationdetails) !==
																				String(undefined) &&
																				healthdeclarationdetails.length > 0
																				? healthdeclarationdetails.toUpperCase()
																				: ""}
																		</span>
																	</p>
																	: null
															}
															{
																(sufferedlongtermillness && String(sufferedlongtermillness) === 'yes') ||
																	(leaveforneckinjury && String(leaveforneckinjury) === 'yes') ||
																	(neckinjuries && String(neckinjuries) === 'yes') ||
																	(sixweeksillness && String(sixweeksillness) === 'yes') ||
																	(communicabledisease && String(communicabledisease) === 'yes') ||
																	(medicalattention && String(medicalattention) === 'yes') ?
																	<p>
																		<span className="left-views">
																			How many days have you been absent from work
																			due to illness in the last 12 months?
                                      <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{absentfromwork &&
																				String(absentfromwork) !==
																				String(undefined) &&
																				absentfromwork.length > 0
																				? absentfromwork.toUpperCase()
																				: ""}
																		</span>
																	</p>
																	: null
															}

															<p>
																<span className="left-views">
																	Are you registered disabled?{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{registereddisabled &&
																		String(registereddisabled) !==
																		String(undefined) &&
																		registereddisabled.length > 0
																		? registereddisabled.toUpperCase()
																		: ""}
																</span>
															</p>



														</div>
													</div>
												</div>
											</li>
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleHealthMedical
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianHealth("HealthMedical")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleHealthMedical
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianHealth("HealthMedical")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Medical History 2
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleHealthMedical
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Do you have any
																	illness/impairment/disability (physical or
                                  psychological) which may affect your work?{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{medicalillness &&
																		String(medicalillness) !==
																		String(undefined) &&
																		medicalillness.length > 0
																		? medicalillness.toUpperCase()
																		: ""}
																</span>
															</p>
															{
																medicalillness && String(medicalillness) === 'yes' ?
																	<p>
																		<span className="left-views">Provided details <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.medicalillness_notes && this.state.medicalillness_notes.length > 0 && String(this.state.medicalillness_notes) !== String(undefined) ? this.state.medicalillness_notes : null}
																		</span>
																	</p>
																	: null
															}
															<p>
																<span className="left-views">
																	Have you ever had any
																	illness/impairment/disability which may have
																	been caused or made worse by your work?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{medicalillnesscaused &&
																		String(medicalillnesscaused) !==
																		String(undefined) &&
																		medicalillnesscaused.length > 0
																		? medicalillnesscaused.toUpperCase()
																		: ""}
																</span>
															</p>
															{
																medicalillnesscaused && String(medicalillnesscaused) === 'yes' ?
																	<p>
																		<span className="left-views">Provided details <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.medicalillnesscaused_notes && this.state.medicalillnesscaused_notes.length > 0 && String(this.state.medicalillnesscaused_notes) !== String(undefined) ? this.state.medicalillnesscaused_notes : null}
																		</span>
																	</p>
																	: null
															}
															<p>
																<span className="left-views">
																	Are you having, or waiting for treatment
																	(including medication) or investigations at
																	present? If your answer is yes, please
																	provide further details of the condition,
																	treatment and dates?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{treatment &&
																		String(treatment) !== String(undefined) &&
																		treatment.length > 0
																		? treatment.toUpperCase()
																		: ""}
																</span>
															</p>
															{
																treatment && String(treatment) === 'yes' ?
																	<p>
																		<span className="left-views">Provided details <span className="col-qus">:</span>
																		</span>
																		<span className="right-views">
																			{this.state.treatment_notes && this.state.treatment_notes.length > 0 && String(this.state.treatment_notes) !== String(undefined) ? this.state.treatment_notes : null}
																		</span>
																	</p>
																	: null
															}
															<p>
																<span className="left-views">
																	Do you think you may need any adjustments or
																	assistance to help you to do the job?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{needanyadjustments &&
																		String(needanyadjustments) !==
																		String(undefined) &&
																		needanyadjustments.length > 0
																		? needanyadjustments.toUpperCase()
																		: ""}
																</span>
															</p>

															{needanyadjustments &&
																needanyadjustments.toUpperCase() === "YES" ? (
																<p>
																	<span className="left-views">
																		Notes
                                    <span className="col-qus">:</span>
																	</span>
																	<span className="right-views">
																		{needanyadjustmentsnotes &&
																			String(needanyadjustmentsnotes) !==
																			String(undefined) &&
																			needanyadjustmentsnotes.length > 0
																			? needanyadjustmentsnotes
																			: ""}
																	</span>
																</p>
															) : null}
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleHealthTuberculosis
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianHealth(
																	"HealthTuberculosis"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleHealthTuberculosis
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianHealth(
																	"HealthTuberculosis"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Tuberculosis
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleHealthTuberculosis
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																{" "}
                                Clinical diagnosis and management of
                                tuberculosis, and measures for its prevention
                                and control (NICE 2006){" "}
															</p>
															<p>
																<span className="left-views">
																	Have you lived continuously in the UK for
																	the last 5 years
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{livedUK &&
																		String(livedUK) !== String(undefined) &&
																		livedUK.length > 0
																		? livedUK.toUpperCase()
																		: ""}
																</span>
															</p>{" "}
															{livedUK && livedUK.toUpperCase() === "NO" ? (
																<p>
																	<span className="left-views">
																		Please list all the countries that you
																		have lived in over the last 5 years
                                    <span className="col-qus">:</span>
																	</span>
																	<span className="right-views">
																		{livedUKnotes &&
																			String(livedUKnotes) !==
																			String(undefined) &&
																			livedUKnotes.length > 0
																			? livedUKnotes
																			: ""}
																	</span>
																</p>
															) : null}
															<p>
																<span className="left-views">
																	Have you had a BCG vaccination in relation
																	to Tuberculosis?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{BCGvaccination &&
																		String(BCGvaccination) !==
																		String(undefined) &&
																		BCGvaccination.length > 0
																		? BCGvaccination.toUpperCase()
																		: ""}
																</span>
															</p>{" "}
															{BCGvaccination &&
																BCGvaccination.toUpperCase() === "YES" ? (
																<p>
																	<span className="left-views">
																		Date
                                    <span className="col-qus">:</span>
																	</span>
																	<span className="right-views">
																		{BCGvaccinationdate === "" || String(BCGvaccinationdate) === String(null) || String(BCGvaccinationdate) === String(undefined) || String(BCGvaccinationdate) === String('Invalid date') ? '' : moment(BCGvaccinationdate).format(
																			"DD-MM-YYYY"
																		)}
																	</span>
																</p>
															) : null}
															<p>
																<span className="left-views">
																	A cough which has lasted for more than 3
																	weeks
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{cough &&
																		String(cough) !== String(undefined) &&
																		cough.length > 0
																		? cough.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Unexplained weight loss
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{weightloss &&
																		String(weightloss) !== String(undefined) &&
																		weightloss.length > 0
																		? weightloss.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Unexplained fever
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{fever &&
																		String(fever) !== String(undefined) &&
																		fever.length > 0
																		? fever.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Have you had tuberculosis (TB) or been in
																	recent contact with open TB
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{TB &&
																		String(TB) !== String(undefined) &&
																		TB.length > 0
																		? TB.toUpperCase()
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span className={`accfun ${this.state.acoordianTogglecovidvaccination ? "active" : ""}`} onClick={() => this.onToggleAccordianHealth("COVIDVACCINATION")}	>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span className={`accfun ${this.state.acoordianTogglecovidvaccination ? "" : "active"}`} onClick={() => this.onToggleAccordianHealth("COVIDVACCINATION")}	>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
														COVID vaccination History
													</h4>
													<div className={`req-levels  ${this.state.acoordianTogglecovidvaccination ? "accordian" : ""}`}	>
														<div className="req-bor">
															<p>
																<span className="left-views">Are You Vaccinated?<span className="col-qus">:</span></span>
																<span className="right-views">
																	{this.state.covidVaccination && CheckValue(this.state.covidVaccination) ? this.state.covidVaccination : ''}
																</span>
															</p>{" "}
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleHealthHISTORY
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianHealth("HealthHISTORY")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleHealthHISTORY
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianHealth("HealthHISTORY")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Medical History
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleHealthHISTORY
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Heart/Circulatory Illness/Hypertension
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{heartCirculatory &&
																		String(heartCirculatory) !==
																		String(undefined) &&
																		heartCirculatory.length > 0
																		? heartCirculatory.toUpperCase()
																		: ""}
																</span>
															</p>{" "}
															<p>
																<span className="left-views">
																	Diabetes
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{diabetes &&
																		String(diabetes) !== String(undefined) &&
																		diabetes.length > 0
																		? diabetes.toUpperCase()
																		: ""}
																</span>
															</p>{" "}
															<p>
																<span className="left-views">
																	Asthma/Hay fever
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{asthma &&
																		String(asthma) !== String(undefined) &&
																		asthma.length > 0
																		? asthma.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Bronchitis/Pneumonia/Pleurisy
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{bronchitis &&
																		String(bronchitis) !== String(undefined) &&
																		bronchitis.length > 0
																		? bronchitis.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Epilepsy
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{epilepsy &&
																		String(epilepsy) !== String(undefined) &&
																		epilepsy.length > 0
																		? epilepsy.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Headaches/Migraine
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{headaches &&
																		String(headaches) !== String(undefined) &&
																		headaches.length > 0
																		? headaches.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Psychiatric Illness/Anxiety/Depression
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{psychiatric &&
																		String(psychiatric) !== String(undefined) &&
																		psychiatric.length > 0
																		? psychiatric.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Dermatitis/Psoriasis/Eczema
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{dermatitis &&
																		String(dermatitis) !== String(undefined) &&
																		dermatitis.length > 0
																		? dermatitis.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Back problems
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{backProblems &&
																		String(backProblems) !==
																		String(undefined) &&
																		backProblems.length > 0
																		? backProblems.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Recurrent infections
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{recurrentInfections &&
																		String(recurrentInfections) !==
																		String(undefined) &&
																		recurrentInfections.length > 0
																		? recurrentInfections.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Hepatitis/Jaundice
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{hepatitis &&
																		String(hepatitis) !== String(undefined) &&
																		hepatitis.length > 0
																		? hepatitis.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Chicken pox or Shingles?
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{chickenpox &&
																		String(chickenpox) !== String(undefined) &&
																		chickenpox.length > 0
																		? chickenpox.toUpperCase()
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleHealthImmunisation
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianHealth(
																	"HealthImmunisation"
																)
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleHealthImmunisation
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianHealth(
																	"HealthImmunisation"
																)
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Immunisation History
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleHealthImmunisation
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Varicella
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{varicella &&
																		String(varicella) !== String(undefined) &&
																		varicella.length > 0
																		? varicella.toUpperCase()
																		: ""}
																</span>
															</p>{" "}
															<p>
																<span className="left-views">
																	Tuberculosis including BCG
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{tuberculosis &&
																		String(tuberculosis) !==
																		String(undefined) &&
																		tuberculosis.length > 0
																		? tuberculosis.toUpperCase()
																		: ""}
																</span>
															</p>{" "}
															<p>
																<span className="left-views">
																	Rubella (German Measles)
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{rubella &&
																		String(rubella) !== String(undefined) &&
																		rubella.length > 0
																		? rubella.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Poliomyelitis
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{poliomyelitis &&
																		String(poliomyelitis) !==
																		String(undefined) &&
																		poliomyelitis.length > 0
																		? poliomyelitis.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Hepatitis B
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{hepatitisB &&
																		String(hepatitisB) !== String(undefined) &&
																		hepatitisB.length > 0
																		? hepatitisB.toUpperCase()
																		: ""}
																</span>
															</p>
															{/* <p>
																<span className="left-views">
																	HIV
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{HIV &&
																		String(HIV) !== String(undefined) &&
																		HIV.length > 0
																		? HIV.toUpperCase()
																		: ""}
																</span>
															</p> */}
															<p>
																<span className="left-views">
																	Tetanus
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{tetanus &&
																		String(tetanus) !== String(undefined) &&
																		tetanus.length > 0
																		? tetanus.toUpperCase()
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Typhoid
                                  <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{typhoid &&
																		String(typhoid) !== String(undefined) &&
																		typhoid.length > 0
																		? typhoid.toUpperCase()
																		: ""}
																</span>
															</p>
															{/* <p>
                                <span className="left-views">
                                  Back problems
                                    <span className="col-qus">:</span>
                                </span>
                                <span className="right-views">
                                  {backProblems &&
                                    String(backProblems) !==
                                    String(undefined) &&
                                    backProblems.length > 0
                                    ? backProblems.toUpperCase()
                                    : ""}
                                </span>
                              </p> */}
														</div>
													</div>
												</div>
											</li>

											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianToggleHealthGP
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianHealth("HealthGP")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianToggleHealthGP
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianHealth("HealthGP")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            GP Details
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianToggleHealthGP
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	GP Name <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{GPname &&
																		String(GPname) !== String(undefined) &&
																		GPname.length > 0
																		? GPname
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Mobile No <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{this.state.GPphone && this.state.GPphone.code && this.state.GPphone.number ? `${append_zero(this.state.GPphone.number)}` : null}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Street Address{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{GPstreetAddress &&
																		String(GPstreetAddress) !==
																		String(undefined) &&
																		GPstreetAddress.length > 0
																		? GPstreetAddress
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	State / Region{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{GPstate &&
																		String(GPstate) !== String(undefined) &&
																		GPstate.length > 0
																		? GPstate
																		: ""}
																</span>
															</p>

															<p>
																<span className="left-views">
																	City <span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{GPcity &&
																		String(GPcity) !== String(undefined) &&
																		GPcity.length > 0
																		? GPcity
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	ZIP / Postal Code{" "}
																	<span className="col-qus">:</span>
																</span>
																<span className="right-views">
																	{GPzip &&
																		String(GPzip) !== String(undefined) &&
																		GPzip.length > 0
																		? GPzip
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>
										</ul>
									</li>

									<li>
										<h2> Payment Details </h2>
										<ul className="mds-lists">
											<li>
												<div className="common-added">
													<h4>
														<span
															className={`accfun ${this.state.acoordianTogglePayment
																? "active"
																: ""
																}`}
															onClick={() =>
																this.onToggleAccordianHealth("Payment")
															}
														>
															<i class="fa fa-minus" aria-hidden="true"></i>
														</span>
														<span
															className={`accfun ${this.state.acoordianTogglePayment
																? ""
																: "active"
																}`}
															onClick={() =>
																this.onToggleAccordianHealth("Payment")
															}
														>
															<i class="fa fa-plus" aria-hidden="true"></i>
														</span>
                            Your Payment Details
                          </h4>
													<div
														className={`req-levels  ${this.state.acoordianTogglePayment
															? "accordian"
															: ""
															}`}
													>
														<div className="req-bor">
															<p>
																<span className="left-views">
																	Name of Bank/Building Society
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{this.state.bankName &&
																		String(this.state.bankName) !==
																		String(undefined) &&
																		this.state.bankName.length > 0
																		? this.state.bankName
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Account Type
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{this.state.accountType &&
																		String(this.state.accountType) !==
																		String(undefined) &&
																		this.state.accountType.length > 0
																		? this.state.accountType
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Account Name
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{this.state.accountName &&
																		String(this.state.accountName) !==
																		String(undefined) &&
																		this.state.accountName.length > 0
																		? this.state.accountName
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Sort Code
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{this.state.bank_sort_code &&
																		String(this.state.bank_sort_code) !==
																		String(undefined) &&
																		this.state.bank_sort_code.length > 0
																		? this.state.bank_sort_code
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Account No
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{this.state.bank_ac &&
																		String(this.state.bank_ac) !==
																		String(undefined) &&
																		this.state.bank_ac.length > 0
																		? this.state.bank_ac
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Post Code
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{this.state.bankName &&
																		String(this.state.bankName) !==
																		String(undefined) &&
																		this.state.bankName.length > 0
																		? this.state.bankName
																		: ""}
																</span>
															</p>
															<p>
																<span className="left-views">
																	Email Address
                                  <span className="col-qus">:</span>
																</span>

																<span className="right-views">
																	{this.state.bankEmail &&
																		String(this.state.bankEmail) !==
																		String(undefined) &&
																		this.state.bankEmail.length > 0
																		? this.state.bankEmail
																		: ""}
																</span>
															</p>
														</div>
													</div>
												</div>
											</li>
										</ul>
									</li>
								</ul>
							</div>

						</div>
					</div>

					<Modal
						isOpen={this.state.fileviewmodal}
						toggle={() => this.setState({ fileviewmodal: false })}
						className="requs-pops"
						backdrop={"static"}
						external={externalCloseBtn}
					>
						<ModalHeader>
							<Button className="close" onClick={() => this.FileView("")}>
								<i className="fa fa-times" aria-hidden="true"></i>
							</Button>
						</ModalHeader>
						<ModalBody>
							<div className="img-views">
								{filepath && String(fileext) === String("docx") ? (
									<embed src={filepath} width="100%" height="100%" />
								) : filepath && String(fileext) === String("pdf") ? (
									<embed src={filepath} width="100%" height="100%" />
								) : filepath && String(fileext) === String("xslx") ? (
									<embed src={filepath} width="100%" height="100%" />
								) : (
									<img style={{ width: "100%", height: "100%" }} alt="imgviewer" src={filepath} />
								)}
								{/* {filepath && fileext && (
                        <FileViewer
                            fileType={fileext}
                            filePath={filepath}
                            onError={() =>
                                toast.error("File Not Found/Supported")
                            }
                        />
                    )} */}
							</div>
						</ModalBody>
					</Modal>
				</Fragment>
			</div>
		);
	}
}
export default CandidateView;
